// (() => {
//   const TAG = 'product-quantity-custom-fields';

//   if (customElements.get(TAG)) return;

//   class ProductQuantityCustomFields extends HTMLElement {
//     constructor() {
//       super();

//       this.sectionId = this.dataset.sectionId || '';
//       this.blockId = this.dataset.blockId || '';
//       this.productFormId = this.dataset.productFormId || '';

//       this.enableVariantSelectors =
//         this.dataset.enableVariantSelectors === 'true';

//       this.customEnabled =
//         (this.dataset.nameEnabled ?? this.dataset.customEnabled) === 'true';

//       this.customRequired =
//         this.dataset.customRequired === 'true';

//       this.propertyName =
//         (this.dataset.propertyName || 'Name').trim() || 'Name';

//       this.customImageEnabled =
//         this.dataset.customImageEnabled === 'true';

//       this.customImageRequired =
//         this.dataset.customImageRequired === 'true';

//       this.customImagePropertyName =
//         (this.dataset.customImagePropertyName || 'Custom Image').trim() || 'Custom Image';

//       this.customImageRequiredMessage =
//         (this.dataset.customImageRequiredMessage || 'Please add a photo.').trim() || 'Please add a photo.';

//       this.photosByIndex = new Map();

//       this.showGifts =
//         this.dataset.showGifts === 'true';

//       this.hideAlternativeButtons =
//         this.dataset.hideAlternativeButtons === 'true';

//       this.debugEnabled =
//         this.dataset.debug === 'true';

//       this.isSubmitting = false;

//       this.bound = {};
//       this._interceptorTarget = null;

//       // Performance caches. The PQCF DOM is static for the lifetime of this
//       // custom element, so cache hot-path lookups and rebuild them whenever
//       // Shopify recreates the section/component.
//       this._offerRows = new WeakMap();
//       this._rowControls = new WeakMap();
//       this._rowOptions = new WeakMap();
//       this._offerUi = new WeakMap();
//       this._giftLocks = new WeakMap();
//       this._customItems = [];
//       this._customItemMap = new Map();
//       this._customUi = new WeakMap();
//       this._customPanel = null;
//       this._activeOffer = null;
//       this._cartDrawer = null;
//       this._cartDrawerEl = null;
//       this.variantOptionsMap = new Map();
//       this._selectOptionCatalog = new WeakMap();
//     }

//     connectedCallback() {
//       if (this.dataset.pqcfInitialized === 'true') {
//         return;
//       }

//       this.dataset.pqcfInitialized = 'true';

//       this.variants = this.readVariants();

//       this.variantMap = new Map(
//         this.variants.map((variant) => [
//           String(variant.id),
//           variant
//         ])
//       );

//       this.variantOptionsMap = new Map();
//       this._selectOptionCatalog = new WeakMap();
//       this.variantPrefixMap = new Map();
//       this.variantValueMap = new Map();

//       this.variants.forEach((variant) => {
//         if (!Array.isArray(variant.options)) return;

//         const key =
//           this.makeVariantOptionsKey(variant.options);

//         // Keep Shopify order deterministic if duplicate combinations ever exist.
//         if (!this.variantOptionsMap.has(key)) {
//           this.variantOptionsMap.set(key, variant);
//         }

//         for (let index = 0; index < variant.options.length; index += 1) {
//           const valueKey =
//             this.makeVariantValueKey(index, variant.options[index]);

//           if (!this.variantValueMap.has(valueKey)) {
//             this.variantValueMap.set(valueKey, []);
//           }

//           this.variantValueMap.get(valueKey).push(variant);

//           const prefixKey =
//             this.makeVariantPrefixKey(
//               variant.options,
//               index + 1
//             );

//           if (!this.variantPrefixMap.has(prefixKey)) {
//             this.variantPrefixMap.set(prefixKey, []);
//           }

//           this.variantPrefixMap.get(prefixKey).push(variant);
//         }
//       });

//       this.offers = Array.from(
//         this.querySelectorAll('[data-pqcf-offer]')
//       );

//       this.gifts = Array.from(
//         this.querySelectorAll('[data-pqcf-gift]')
//       );

//       this.cacheStaticDom();
//       this.resolveThemeElements();

//       this.bound.onRootChange =
//         this.onRootChange.bind(this);

//       this.bound.onRootClick =
//         this.onRootClick.bind(this);

//       this.bound.onProductAreaClickCapture =
//         this.onProductAreaClickCapture.bind(this);

//       this.bound.onProductAreaSubmitCapture =
//         this.onProductAreaSubmitCapture.bind(this);

//       this.bound.onExternalChange =
//         this.onExternalChange.bind(this);

//       this.addEventListener(
//         'change',
//         this.bound.onRootChange
//       );

//       this.addEventListener(
//         'input',
//         this.bound.onRootChange
//       );

//       this.addEventListener(
//         'click',
//         this.bound.onRootClick
//       );

//       this.bindThemeInterceptors();

//       if (this.productInfo) {
//         this.productInfo.addEventListener(
//           'change',
//           this.bound.onExternalChange,
//           true
//         );
//       }

//       this.initializeRows();
//       this.ensureActiveOffer();
//       this.refreshAllOfferPrices();
//       this.updateGiftStates();
//       this.updateCustomizationVisibility();
//       this.refreshPhotoUIs();
//       this.applyAlternativeButtonPolicy();

//       requestAnimationFrame(() => {
//         this.resolveThemeElements();
//         this.bindThemeInterceptors();
//         this.applyAlternativeButtonPolicy();
//       });

//       this.debug('initialized', {
//         form: this.form,
//         mainButton: this.mainButton,
//         productFormElement: this.productFormElement,
//         productInfo: this.productInfo
//       });
//     }

//     disconnectedCallback() {
//       this.removeEventListener(
//         'change',
//         this.bound.onRootChange
//       );

//       this.removeEventListener(
//         'input',
//         this.bound.onRootChange
//       );

//       this.removeEventListener(
//         'click',
//         this.bound.onRootClick
//       );

//       this.photosByIndex.forEach((record) => {
//         if (record?.previewUrl) {
//           URL.revokeObjectURL(record.previewUrl);
//         }
//       });
//       this.photosByIndex.clear();

//       this.unbindThemeInterceptors();

//       if (this.productInfo) {
//         this.productInfo.removeEventListener(
//           'change',
//           this.bound.onExternalChange,
//           true
//         );
//       }

//       this.removeAlternativeButtonPolicy();

//       this._customItems = [];
//       this._customItemMap.clear();
//       this._activeOffer = null;
//       this._cartDrawer = null;
//       this._cartDrawerEl = null;

//       this.dataset.pqcfInitialized = 'false';
//     }

//     makeVariantOptionsKey(options) {
//       return (options || [])
//         .map((value) => String(value))
//         .join('\u001f');
//     }

//     makeVariantPrefixKey(options, length) {
//       const safeLength = Math.max(0, Number(length) || 0);
//       return `${safeLength}\u001e${this.makeVariantOptionsKey(
//         (options || []).slice(0, safeLength)
//       )}`;
//     }

//     makeVariantValueKey(index, value) {
//       return `${Number(index) || 0}\u001e${String(value)}`;
//     }

//     cacheStaticDom() {
//       this._offerRows = new WeakMap();
//       this._rowControls = new WeakMap();
//       this._rowOptions = new WeakMap();
//       this._offerUi = new WeakMap();
//       this._giftLocks = new WeakMap();
//       this._customUi = new WeakMap();

//       this.offers.forEach((offer) => {
//         const rows = Array.from(
//           offer.querySelectorAll('[data-pqcf-item]')
//         ).sort(
//           (a, b) =>
//             Number(a.dataset.itemIndex || 0) -
//             Number(b.dataset.itemIndex || 0)
//         );

//         this._offerRows.set(offer, rows);

//         rows.forEach((row) => {
//           this._rowControls.set(
//             row,
//             Array.from(
//               row.querySelectorAll(
//                 '[data-pqcf-option], [data-pqcf-field-control], [data-pqcf-image-input], [data-pqcf-image-choose], [data-pqcf-image-change], [data-pqcf-image-remove]'
//               )
//             )
//           );

//           this._rowOptions.set(
//             row,
//             Array.from(
//               row.querySelectorAll('[data-pqcf-option]')
//             ).sort(
//               (a, b) =>
//                 Number(a.dataset.optionPosition) -
//                 Number(b.dataset.optionPosition)
//             )
//           );

//           this._rowOptions.get(row).forEach((select) => {
//             if (!this._selectOptionCatalog.has(select)) {
//               this._selectOptionCatalog.set(
//                 select,
//                 Array.from(select.options).map((option) => ({
//                   value: String(option.value),
//                   label: option.textContent || option.label || String(option.value)
//                 }))
//               );
//             }
//           });
//         });

//         this._offerUi.set(offer, {
//           price: offer.querySelector('[data-pqcf-price]'),
//           compare: offer.querySelector('[data-pqcf-compare-price]'),
//           label: offer.querySelector('[data-pqcf-label]'),
//           caption: offer.querySelector('[data-pqcf-caption]'),
//           savings: offer.querySelector('[data-pqcf-savings]')
//         });
//       });

//       this._customPanel =
//         this.querySelector('[data-pqcf-custom-panel]');

//       this._customItems = Array.from(
//         this.querySelectorAll('[data-pqcf-custom-item]')
//       ).sort(
//         (a, b) =>
//           this.getCustomizationItemIndex(a) -
//           this.getCustomizationItemIndex(b)
//       );

//       this._customItemMap = new Map(
//         this._customItems.map((item) => [
//           this.getCustomizationItemIndex(item),
//           item
//         ])
//       );

//       this._customItems.forEach((item) => {
//         this._customUi.set(item, {
//           fieldControls: Array.from(
//             item.querySelectorAll('[data-pqcf-field-control]')
//           ),
//           allControls: Array.from(
//             item.querySelectorAll(
//               '[data-pqcf-field-control], [data-pqcf-image-input], [data-pqcf-image-choose], [data-pqcf-image-change], [data-pqcf-image-remove]'
//             )
//           ),
//           empty: item.querySelector('[data-pqcf-image-empty]'),
//           preview: item.querySelector('[data-pqcf-image-preview]'),
//           image: item.querySelector('[data-pqcf-image-preview-img]'),
//           filename: item.querySelector('[data-pqcf-image-filename]'),
//           input: item.querySelector('[data-pqcf-image-input]'),
//           choose: item.querySelector('[data-pqcf-image-choose]'),
//           fieldError: item.querySelector('[data-pqcf-field-error]'),
//           imageError: item.querySelector('[data-pqcf-image-error]')
//         });
//       });

//       this.gifts.forEach((gift) => {
//         this._giftLocks.set(
//           gift,
//           gift.querySelector('[data-pqcf-gift-lock]')
//         );
//       });
//     }

//     getOfferRows(offer) {
//       if (!offer) return [];

//       const cached = this._offerRows.get(offer);
//       if (cached) return cached;

//       const rows = Array.from(
//         offer.querySelectorAll('[data-pqcf-item]')
//       ).sort(
//         (a, b) =>
//           Number(a.dataset.itemIndex || 0) -
//           Number(b.dataset.itemIndex || 0)
//       );

//       this._offerRows.set(offer, rows);
//       return rows;
//     }

//     getCartDrawer() {
//       if (this._cartDrawer?.isConnected) {
//         return this._cartDrawer;
//       }

//       this._cartDrawer = document.querySelector('cart-drawer');
//       return this._cartDrawer;
//     }

//     resolveThemeElements() {
//       this.form =
//         document.getElementById(
//           this.productFormId
//         );

//       this.productFormElement =
//         document.getElementById(
//           `ProductForm-${this.sectionId}`
//         );

//       this.mainButton =
//         document.getElementById(
//           `ProductSubmitButton-${this.sectionId}`
//         );

//       this.secondaryButton =
//         document.getElementById(
//           `SectionAtcBtn-${this.sectionId}`
//         );

//       this.productInfo =
//         document.getElementById(
//           `ProductInfo-${this.sectionId}`
//         );
//     }

//     bindThemeInterceptors() {
//       if (this._interceptorTarget) {
//         return;
//       }

//       const target =
//         this.productInfo ||
//         this.productFormElement ||
//         this.form;

//       if (!target) {
//         this.debug(
//           'No theme interception target found yet.'
//         );

//         return;
//       }

//       target.addEventListener(
//         'click',
//         this.bound.onProductAreaClickCapture,
//         true
//       );

//       target.addEventListener(
//         'submit',
//         this.bound.onProductAreaSubmitCapture,
//         true
//       );

//       this._interceptorTarget = target;
//     }

//     unbindThemeInterceptors() {
//       if (!this._interceptorTarget) {
//         return;
//       }

//       this._interceptorTarget.removeEventListener(
//         'click',
//         this.bound.onProductAreaClickCapture,
//         true
//       );

//       this._interceptorTarget.removeEventListener(
//         'submit',
//         this.bound.onProductAreaSubmitCapture,
//         true
//       );

//       this._interceptorTarget = null;
//     }

//     readVariants() {
//       const script =
//         this.querySelector(
//           '[data-pqcf-variants]'
//         );

//       if (!script) {
//         return [];
//       }

//       try {
//         const variants =
//           JSON.parse(
//             script.textContent || '[]'
//           );

//         return Array.isArray(variants)
//           ? variants
//           : [];
//       } catch (error) {
//         console.error(
//           '[PQCF] Invalid variants JSON',
//           error
//         );

//         return [];
//       }
//     }

//     initializeRows() {
//       this.offers.forEach((offer) => {
//         this.getOfferRows(offer).forEach((row) => {
//           if (this.enableVariantSelectors) {
//             this.resolveRowVariant(
//               row,
//               false
//             );
//           } else {
//             const variant =
//               this.variantMap.get(
//                 String(
//                   row.dataset.variantId
//                 )
//               );

//             if (variant) {
//               this.applyVariantToRow(
//                 row,
//                 variant,
//                 false
//               );
//             }
//           }
//         });
//       });
//     }

//     ensureActiveOffer() {
//       let radio =
//         this.querySelector(
//           '[data-pqcf-offer-radio]:checked'
//         );

//       if (!radio) {
//         radio =
//           this.querySelector(
//             '[data-pqcf-offer-radio]'
//           );

//         if (radio) {
//           radio.checked = true;
//         }
//       }

//       if (radio) {
//         this.activateOffer(
//           radio.closest(
//             '[data-pqcf-offer]'
//           )
//         );
//       }
//     }

//     onRootChange(event) {
//       const radio =
//         event.target.closest(
//           '[data-pqcf-offer-radio]'
//         );

//       if (
//         radio &&
//         this.contains(radio)
//       ) {
//         this.activateOffer(
//           radio.closest(
//             '[data-pqcf-offer]'
//           )
//         );

//         return;
//       }

//       const customItem =
//         event.target.closest(
//           '[data-pqcf-custom-item]'
//         );

//       if (
//         customItem &&
//         this.contains(customItem)
//       ) {
//         if (
//           event.target.matches(
//             '[data-pqcf-image-input]'
//           )
//         ) {
//           const itemIndex =
//             this.getCustomizationItemIndex(
//               customItem
//             );

//           const file =
//             event.target.files?.[0] ||
//             null;

//           if (file) {
//             this.setPhoto(
//               itemIndex,
//               file
//             );
//           }

//           return;
//         }

//         if (
//           event.target.matches(
//             '[data-pqcf-field-control]'
//           )
//         ) {
//           this.clearRowFieldError(
//             customItem
//           );
//           this.clearGlobalError();
//         }

//         return;
//       }

//       const row =
//         event.target.closest(
//           '[data-pqcf-item]'
//         );

//       if (
//         !row ||
//         !this.contains(row)
//       ) {
//         return;
//       }

//       if (
//         event.target.matches(
//           '[data-pqcf-option]'
//         )
//       ) {
//         const changedOptionIndex =
//           Math.max(
//             0,
//             Number(event.target.dataset.optionPosition || 1) - 1
//           );

//         this.resolveRowVariant(
//           row,
//           true,
//           changedOptionIndex
//         );

//         this.updateOfferPrice(
//           row.closest(
//             '[data-pqcf-offer]'
//           )
//         );
//       }
//     }

//     onRootClick(event) {
//       const button =
//         event.target.closest?.(
//           '[data-pqcf-image-choose], [data-pqcf-image-change], [data-pqcf-image-remove]'
//         );

//       if (
//         !button ||
//         !this.contains(button)
//       ) {
//         return;
//       }

//       const customItem =
//         button.closest(
//           '[data-pqcf-custom-item]'
//         );

//       if (!customItem) return;

//       event.preventDefault();

//       const itemIndex =
//         this.getCustomizationItemIndex(
//           customItem
//         );

//       if (
//         button.matches(
//           '[data-pqcf-image-remove]'
//         )
//       ) {
//         this.removePhoto(
//           itemIndex
//         );

//         return;
//       }

//       const imageInput =
//         this._customUi.get(customItem)?.input ||
//         customItem.querySelector('[data-pqcf-image-input]');

//       imageInput?.click();
//     }

//     activateOffer(activeOffer) {
//       if (!activeOffer) return;

//       this._activeOffer = activeOffer;

//       this.offers.forEach((offer) => {
//         const active =
//           offer === activeOffer;

//         offer.classList.toggle(
//           'pqcf__offer--selected',
//           active
//         );

//         offer.dataset.active =
//           active ? 'true' : 'false';

//         this.getOfferRows(offer).forEach((row) => {
//           row.dataset.active =
//             active ? 'true' : 'false';

//           this.setRowControlsDisabled(
//             row,
//             !active
//           );

//           if (!active) {
//             this.clearRowFieldError(row);
//             this.clearRowImageError(row);
//             this.clearRowError(row);
//           }
//         });
//       });

//       this.clearGlobalError();

//       this.updateOfferPrice(
//         activeOffer
//       );

//       this.updateGiftStates();
//       this.updateCustomizationVisibility();
//       this.refreshPhotoUIs();
//     }

//     setRowControlsDisabled(
//       row,
//       disabled
//     ) {
//       const controls =
//         this._rowControls.get(row) ||
//         Array.from(
//           row.querySelectorAll(
//             '[data-pqcf-option], [data-pqcf-field-control], [data-pqcf-image-input], [data-pqcf-image-choose], [data-pqcf-image-change], [data-pqcf-image-remove]'
//           )
//         );

//       controls.forEach((control) => {
//         if (control.disabled !== disabled) {
//           control.disabled = disabled;
//         }
//       });
//     }

//     getRowSelectors(row) {
//       return (
//         this._rowOptions.get(row) ||
//         Array.from(
//           row.querySelectorAll('[data-pqcf-option]')
//         ).sort(
//           (a, b) =>
//             Number(a.dataset.optionPosition) -
//             Number(b.dataset.optionPosition)
//         )
//       );
//     }

//     getRowSelections(row) {
//       return this.getRowSelectors(row).map(
//         (select) => String(select.value)
//       );
//     }

//     findExactVariant(selections) {
//       return (
//         this.variantOptionsMap.get(
//           this.makeVariantOptionsKey(selections)
//         ) ||
//         null
//       );
//     }

//     getVariantsForPrefix(selections, length) {
//       const safeLength = Math.max(0, Number(length) || 0);

//       if (safeLength === 0) {
//         return this.variants;
//       }

//       return (
//         this.variantPrefixMap.get(
//           this.makeVariantPrefixKey(
//             selections,
//             safeLength
//           )
//         ) ||
//         []
//       );
//     }

//     getVariantsForOptionValue(index, value) {
//       return (
//         this.variantValueMap.get(
//           this.makeVariantValueKey(index, value)
//         ) ||
//         []
//       );
//     }

//     chooseBestVariant(candidates, previousSelections, changedOptionIndex = -1) {
//       if (!candidates?.length) return null;

//       let best = null;
//       let bestScore = -1;
//       let bestAvailable = -1;

//       candidates.forEach((variant) => {
//         let score = 0;

//         variant.options.forEach((value, index) => {
//           if (index === changedOptionIndex) return;
//           if (String(value) === String(previousSelections[index] ?? '')) {
//             score += 1;
//           }
//         });

//         const availableScore = variant.available ? 1 : 0;

//         if (
//           !best ||
//           score > bestScore ||
//           (score === bestScore && availableScore > bestAvailable)
//         ) {
//           best = variant;
//           bestScore = score;
//           bestAvailable = availableScore;
//         }
//       });

//       return best;
//     }

//     syncSelectorsToVariant(row, variant) {
//       const selectors = this.getRowSelectors(row);

//       selectors.forEach((select, index) => {
//         const nextValue = variant?.options?.[index];
//         if (typeof nextValue === 'undefined') return;

//         const normalizedValue = String(nextValue);
//         if (select.value !== normalizedValue) {
//           select.value = normalizedValue;
//         }
//       });
//     }

//     refreshOptionAvailability(row) {
//       const selectors = this.getRowSelectors(row);
//       const selections = selectors.map((select) => String(select.value));

//       selectors.forEach((select, optionIndex) => {
//         const catalog =
//           this._selectOptionCatalog.get(select) ||
//           Array.from(select.options).map((option) => ({
//             value: String(option.value),
//             label: option.textContent || option.label || String(option.value)
//           }));

//         if (!this._selectOptionCatalog.has(select)) {
//           this._selectOptionCatalog.set(select, catalog);
//         }

//         const prefixBefore = selections.slice(0, optionIndex);
//         const allowed = [];

//         catalog.forEach((entry) => {
//           const candidateSelections = [
//             ...prefixBefore,
//             entry.value
//           ];

//           const exists =
//             this.getVariantsForPrefix(
//               candidateSelections,
//               optionIndex + 1
//             ).length > 0;

//           if (exists) {
//             allowed.push(entry);
//           }
//         });

//         const currentValues =
//           Array.from(select.options).map((option) => String(option.value));

//         const nextValues = allowed.map((entry) => entry.value);
//         const sameOptions =
//           currentValues.length === nextValues.length &&
//           currentValues.every((value, index) => value === nextValues[index]);

//         if (!sameOptions) {
//           const selectedValue = String(select.value);
//           const fragment = document.createDocumentFragment();

//           allowed.forEach((entry) => {
//             const option = document.createElement('option');
//             option.value = entry.value;
//             option.textContent = entry.label;
//             option.selected = entry.value === selectedValue;
//             fragment.appendChild(option);
//           });

//           select.replaceChildren(fragment);
//         }
//       });
//     }

//     resolveRowVariant(
//       row,
//       announceError = true,
//       changedOptionIndex = -1
//     ) {
//       const selectors = this.getRowSelectors(row);

//       if (!selectors.length) {
//         return (
//           this.variantMap.get(
//             String(row.dataset.variantId)
//           ) ||
//           null
//         );
//       }

//       const selections = selectors.map(
//         (select) => String(select.value)
//       );

//       let variant = this.findExactVariant(selections);

//       if (!variant) {
//         const changedIndex =
//           Number.isInteger(changedOptionIndex) &&
//           changedOptionIndex >= 0 &&
//           changedOptionIndex < selections.length
//             ? changedOptionIndex
//             : -1;

//         if (changedIndex >= 0) {
//           // Normal Shopify cascade: preserve every option up to and including
//           // the user's changed option, then normalize only downstream options.
//           const prefixCandidates =
//             this.getVariantsForPrefix(
//               selections,
//               changedIndex + 1
//             );

//           variant = this.chooseBestVariant(
//             prefixCandidates,
//             selections,
//             changedIndex
//           );

//           // Defensive fallback for a value injected by another script or stale DOM:
//           // preserve the value the user changed whenever that value exists anywhere.
//           if (!variant) {
//             variant = this.chooseBestVariant(
//               this.getVariantsForOptionValue(
//                 changedIndex,
//                 selections[changedIndex]
//               ),
//               selections,
//               changedIndex
//             );
//           }
//         } else {
//           const currentVariant =
//             this.variantMap.get(
//               String(row.dataset.variantId || '')
//             ) ||
//             null;

//           variant =
//             currentVariant ||
//             this.variants.find((item) => item.available) ||
//             this.variants[0] ||
//             null;
//         }
//       }

//       if (!variant) {
//         row.dataset.variantId = '';
//         row.dataset.available = 'false';
//         row.classList.add('pqcf__item--unavailable');

//         if (announceError) {
//           this.showRowError(
//             row,
//             'Unable to resolve a valid variant.'
//           );
//         }

//         this.refreshOptionAvailability(row);
//         return null;
//       }

//       this.syncSelectorsToVariant(row, variant);
//       this.refreshOptionAvailability(row);
//       this.applyVariantToRow(
//         row,
//         variant,
//         announceError
//       );

//       this.debug('variant resolved', {
//         itemIndex: row.dataset.itemIndex,
//         changedOptionIndex,
//         selections,
//         resolvedOptions: variant.options,
//         variantId: variant.id,
//         available: variant.available
//       });

//       return variant;
//     }

//     applyVariantToRow(
//       row,
//       variant,
//       announceError = true
//     ) {
//       row.dataset.variantId =
//         String(variant.id);

//       row.dataset.available =
//         variant.available
//           ? 'true'
//           : 'false';

//       row.dataset.price =
//         String(
//           Number(
//             variant.price || 0
//           )
//         );

//       row.dataset.comparePrice =
//         String(
//           Number(
//             variant.compare_at_price ||
//             0
//           )
//         );

//       row.classList.toggle(
//         'pqcf__item--unavailable',
//         !variant.available
//       );

//       const title =
//         row.querySelector(
//           '[data-pqcf-variant-title]'
//         );

//       if (title) {
//         const nextTitle = variant.title || '';
//         if (title.textContent !== nextTitle) {
//           title.textContent = nextTitle;
//         }
//       }

//       const image =
//         row.querySelector(
//           '[data-pqcf-variant-image]'
//         );

//       if (
//         image &&
//         variant.featured_image &&
//         image.getAttribute('src') !== String(variant.featured_image)
//       ) {
//         image.src = variant.featured_image;
//       }

//       if (
//         !variant.available &&
//         announceError
//       ) {
//         this.showRowError(
//           row,
//           'This variant is sold out.'
//         );
//       } else {
//         this.clearRowError(row);
//       }
//     }

//     refreshAllOfferPrices() {
//       this.offers.forEach(
//         (offer) =>
//           this.updateOfferPrice(
//             offer
//           )
//       );
//     }

//     updateOfferPrice(offer) {
//       if (!offer) return;

//       const rows =
//         this.getOfferRows(offer);

//       const total =
//         rows.reduce(
//           (sum, row) =>
//             sum +
//             Number(
//               row.dataset.price || 0
//             ),
//           0
//         );

//       const compareTotal =
//         rows.reduce(
//           (sum, row) => {
//             const price =
//               Number(
//                 row.dataset.price || 0
//               );

//             const compare =
//               Number(
//                 row.dataset.comparePrice ||
//                 0
//               );

//             return (
//               sum +
//               Math.max(
//                 price,
//                 compare || 0
//               )
//             );
//           },
//           0
//         );

//       const percent =
//         Math.max(
//           0,
//           Number(
//             offer.dataset.percentOff ||
//             0
//           )
//         );

//       const fixed =
//         this.parseMoneyInputToCents(
//           offer.dataset.fixedOff ||
//           '0'
//         );

//       const percentDiscount =
//         Math.round(
//           total *
//           (
//             percent /
//             100
//           )
//         );

//       const discount =
//         Math.min(
//           total,
//           percentDiscount +
//           fixed
//         );

//       const displayPrice =
//         Math.max(
//           0,
//           total -
//           discount
//         );

//       const displayCompare =
//         Math.max(
//           compareTotal,
//           total
//         );

//       const amountSaved =
//         Math.max(
//           0,
//           displayCompare -
//           displayPrice
//         );

//       const quantity =
//         Number(
//           offer.dataset.quantity ||
//           rows.length ||
//           0
//         );

//       const tokens = {
//         quantity:
//           String(quantity),

//         price:
//           this.formatMoney(
//             displayPrice
//           ),

//         compare_price:
//           this.formatMoney(
//             displayCompare
//           ),

//         amount_saved:
//           this.formatMoney(
//             amountSaved
//           ),

//         amount_saved_rounded:
//           this.formatMoney(
//             Math.round(
//               amountSaved /
//               100
//             ) *
//             100
//           )
//       };

//       const ui =
//         this._offerUi.get(offer) || {};

//       const priceEl = ui.price || null;
//       const compareEl = ui.compare || null;
//       const labelEl = ui.label || null;
//       const captionEl = ui.caption || null;
//       const savingsEl = ui.savings || null;

//       if (priceEl) {
//         priceEl.textContent =
//           tokens.price;
//       }

//       if (compareEl) {
//         compareEl.textContent =
//           displayCompare >
//           displayPrice
//             ? tokens.compare_price
//             : '';

//         compareEl.hidden =
//           displayCompare <=
//           displayPrice;
//       }

//       if (labelEl) {
//         labelEl.innerHTML =
//           this.replaceTokens(
//             offer.dataset
//               .labelTemplate ||
//             '',
//             tokens
//           );
//       }

//       if (captionEl) {
//         captionEl.innerHTML =
//           this.replaceTokens(
//             offer.dataset
//               .captionTemplate ||
//             '',
//             tokens
//           );
//       }

//       if (savingsEl) {
//         const savingsTemplate =
//           String(
//             offer.dataset
//               .savingsTemplate ||
//             ''
//           ).trim();

//         const showSavings =
//           amountSaved > 0 &&
//           savingsTemplate.length > 0;

//         savingsEl.hidden =
//           !showSavings;

//         savingsEl.innerHTML =
//           showSavings
//             ? this.replaceTokens(
//                 savingsTemplate,
//                 tokens
//               )
//             : '';
//       }

//       if (
//         offer.dataset.active ===
//         'true'
//       ) {
//         this.syncDefaultAtcPrice(
//           displayPrice
//         );
//       }
//     }

//     replaceTokens(
//       template,
//       tokens
//     ) {
//       return String(
//         template || ''
//       )
//         .replaceAll(
//           '[quantity]',
//           tokens.quantity
//         )
//         .replaceAll(
//           '[price]',
//           tokens.price
//         )
//         .replaceAll(
//           '[compare_price]',
//           tokens.compare_price
//         )
//         .replaceAll(
//           '[amount_saved]',
//           tokens.amount_saved
//         )
//         .replaceAll(
//           '[amount_saved_rounded]',
//           tokens.amount_saved_rounded
//         );
//     }

//     parseMoneyInputToCents(value) {
//       const normalized =
//         String(
//           value || '0'
//         )
//           .replace(
//             /[^0-9.,-]/g,
//             ''
//           )
//           .replace(
//             ',',
//             '.'
//           );

//       const number =
//         Number.parseFloat(
//           normalized
//         );

//       return Number.isFinite(
//         number
//       )
//         ? Math.max(
//             0,
//             Math.round(
//               number * 100
//             )
//           )
//         : 0;
//     }

//     formatMoney(cents) {
//       const format =
//         this.dataset.moneyFormat ||
//         '${{amount}}';

//       const value =
//         Number(
//           cents || 0
//         );

//       const placeholderRegex =
//         /\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator|amount_with_apostrophe_separator)\s*\}\}/;

//       const match =
//         format.match(
//           placeholderRegex
//         );

//       const type =
//         match
//           ? match[1]
//           : 'amount';

//       const withDelimiters = (
//         number,
//         precision = 2,
//         thousands = ',',
//         decimal = '.'
//       ) => {
//         const n =
//           Number(number);

//         const fixed =
//           (
//             n / 100
//           ).toFixed(
//             precision
//           );

//         const parts =
//           fixed.split('.');

//         parts[0] =
//           parts[0].replace(
//             /\B(?=(\d{3})+(?!\d))/g,
//             thousands
//           );

//         return parts[1]
//           ? `${parts[0]}${decimal}${parts[1]}`
//           : parts[0];
//       };

//       let formatted;

//       switch (type) {
//         case 'amount_no_decimals':
//           formatted =
//             withDelimiters(
//               value,
//               0,
//               ',',
//               '.'
//             );
//           break;

//         case 'amount_with_comma_separator':
//           formatted =
//             withDelimiters(
//               value,
//               2,
//               '.',
//               ','
//             );
//           break;

//         case 'amount_no_decimals_with_comma_separator':
//           formatted =
//             withDelimiters(
//               value,
//               0,
//               '.',
//               ','
//             );
//           break;

//         case 'amount_with_apostrophe_separator':
//           formatted =
//             withDelimiters(
//               value,
//               2,
//               "'",
//               '.'
//             );
//           break;

//         default:
//           formatted =
//             withDelimiters(
//               value,
//               2,
//               ',',
//               '.'
//             );
//       }

//       return match
//         ? format.replace(
//             placeholderRegex,
//             formatted
//           )
//         : formatted;
//     }

//     getActiveOffer() {
//       if (
//         this._activeOffer?.isConnected &&
//         this.contains(this._activeOffer) &&
//         this._activeOffer.dataset.active === 'true'
//       ) {
//         return this._activeOffer;
//       }

//       this._activeOffer =
//         this.querySelector(
//           '[data-pqcf-offer][data-active="true"]'
//         ) ||
//         this.querySelector(
//           '.pqcf__offer--selected'
//         ) ||
//         null;

//       return this._activeOffer;
//     }

//     getActiveRows() {
//       return this.getOfferRows(
//         this.getActiveOffer()
//       );
//     }

//     getRowItemIndex(row) {
//       return Math.max(
//         1,
//         Number(
//           row?.dataset?.itemIndex ||
//           1
//         ) || 1
//       );
//     }

//     getCustomizationItems() {
//       return this._customItems;
//     }

//     getCustomizationItem(index) {
//       return (
//         this._customItemMap.get(Number(index)) ||
//         null
//       );
//     }

//     getCustomizationItemIndex(item) {
//       return Math.max(
//         1,
//         Number(
//           item?.dataset?.itemIndex ||
//           1
//         ) || 1
//       );
//     }

//     updateCustomizationVisibility() {
//       const panel =
//         this._customPanel?.isConnected
//           ? this._customPanel
//           : this.querySelector('[data-pqcf-custom-panel]');

//       this._customPanel = panel || null;

//       if (!panel) return;

//       const quantity =
//         Math.max(
//           1,
//           this.getSelectedQuantity() || 1
//         );

//       panel.dataset.quantity =
//         String(quantity);

//       panel.setAttribute(
//         'aria-label',
//         `Customization for ${quantity} item${quantity === 1 ? '' : 's'}`
//       );

//       panel.style.setProperty(
//         '--pqcf-custom-columns',
//         String(quantity)
//       );

//       this.getCustomizationItems()
//         .forEach((item) => {
//           const index =
//             this.getCustomizationItemIndex(
//               item
//             );

//           const active =
//             index <= quantity;

//           item.hidden = !active;
//           item.setAttribute(
//             'aria-hidden',
//             active ? 'false' : 'true'
//           );

//           const controls =
//             this._customUi.get(item)?.allControls ||
//             [];

//           controls.forEach((control) => {
//             if (control.disabled === active) {
//               control.disabled = !active;
//             }
//           });

//           if (!active) {
//             this.clearRowFieldError(item);
//             this.clearRowImageError(item);
//           }
//         });
//     }

//     isValidImage(file) {
//       if (!file) return false;

//       const mime =
//         String(file.type || '')
//           .toLowerCase();

//       const validMime = [
//         'image/jpeg',
//         'image/png',
//         'image/webp'
//       ];

//       const mimeOkay =
//         !mime ||
//         validMime.includes(mime);

//       const extOkay =
//         /\.(jpe?g|png|webp)$/i.test(
//           String(file.name || '')
//         );

//       return mimeOkay && extOkay;
//     }

//     setPhoto(index, file) {
//       const numericIndex =
//         Math.max(1, Number(index) || 1);

//       if (!this.isValidImage(file)) {
//         const customItem =
//           this.getCustomizationItem(
//             numericIndex
//           );

//         if (customItem) {
//           this.showRowImageError(
//             customItem,
//             'Please choose a JPG, PNG, or WEBP image.'
//           );
//         }

//         return;
//       }

//       const existing =
//         this.photosByIndex.get(
//           numericIndex
//         );

//       if (existing?.previewUrl) {
//         URL.revokeObjectURL(
//           existing.previewUrl
//         );
//       }

//       this.photosByIndex.set(
//         numericIndex,
//         {
//           file,
//           filename:
//             file.name ||
//             `photo-${numericIndex}`,
//           previewUrl:
//             URL.createObjectURL(file)
//         }
//       );

//       this.clearGlobalError();
//       this.refreshPhotoUIs(
//         numericIndex
//       );
//     }

//     removePhoto(index) {
//       const numericIndex =
//         Math.max(1, Number(index) || 1);

//       const existing =
//         this.photosByIndex.get(
//           numericIndex
//         );

//       if (existing?.previewUrl) {
//         URL.revokeObjectURL(
//           existing.previewUrl
//         );
//       }

//       this.photosByIndex.delete(
//         numericIndex
//       );

//       this.refreshPhotoUIs(
//         numericIndex
//       );
//     }

//     getPhotoForIndex(index) {
//       if (!this.customImageEnabled) {
//         return null;
//       }

//       return (
//         this.photosByIndex.get(
//           Number(index)
//         )?.file ||
//         null
//       );
//     }

//     updatePhotoUiForItem(customItem) {
//       if (!customItem) return;

//       const index =
//         this.getCustomizationItemIndex(
//           customItem
//         );

//       const record =
//         this.photosByIndex.get(index) ||
//         null;

//       const ui =
//         this._customUi.get(customItem) || {};

//       const empty = ui.empty || null;
//       const preview = ui.preview || null;
//       const image = ui.image || null;
//       const filename = ui.filename || null;
//       const input = ui.input || null;

//       if (!empty && !preview) return;

//       if (record) {
//         if (empty) empty.hidden = true;
//         if (preview) preview.hidden = false;
//         if (
//           image &&
//           image.getAttribute('src') !== record.previewUrl
//         ) {
//           image.src = record.previewUrl;
//         }
//         if (filename) {
//           filename.textContent =
//             record.filename || '';
//         }
//         this.clearRowImageError(
//           customItem
//         );
//       } else {
//         if (empty) empty.hidden = false;
//         if (preview) preview.hidden = true;
//         if (image) image.removeAttribute('src');
//         if (filename) filename.textContent = '';
//         if (input) input.value = '';
//       }
//     }

//     refreshPhotoUIs(index = null) {
//       if (!this.customImageEnabled) {
//         return;
//       }

//       this.getCustomizationItems()
//         .forEach((customItem) => {
//           if (
//             index !== null &&
//             this.getCustomizationItemIndex(
//               customItem
//             ) !== Number(index)
//           ) {
//             return;
//           }

//           this.updatePhotoUiForItem(
//             customItem
//           );
//         });
//     }

//     showRowImageError(row, message) {
//       const error =
//         (row ? this._customUi.get(row)?.imageError : null) ||
//         row?.querySelector('[data-pqcf-image-error]');

//       if (error) {
//         error.textContent =
//           message ||
//           this.customImageRequiredMessage;
//         error.hidden = false;
//       }

//       row?.classList.add(
//         'pqcf__item--image-error'
//       );
//     }

//     clearRowImageError(row) {
//       const error =
//         (row ? this._customUi.get(row)?.imageError : null) ||
//         row?.querySelector('[data-pqcf-image-error]');

//       if (error) {
//         error.hidden = true;
//       }

//       row?.classList.remove(
//         'pqcf__item--image-error'
//       );
//     }

//     getCustomValueForIndex(index) {
//       if (!this.customEnabled) {
//         return '';
//       }

//       const customItem =
//         this.getCustomizationItem(index);

//       if (!customItem) {
//         return '';
//       }

//       const controls =
//         this._customUi.get(customItem)?.fieldControls ||
//         [];

//       if (!controls.length) {
//         return '';
//       }

//       const type =
//         customItem.querySelector(
//           '[data-pqcf-custom]'
//         )?.dataset.fieldType ||
//         'text';

//       if (
//         type === 'pills' ||
//         type === 'swatches'
//       ) {
//         return (
//           controls.find(
//             (control) =>
//               control.checked
//           )?.value?.trim() ||
//           ''
//         );
//       }

//       return String(
//         controls[0].value || ''
//       ).trim();
//     }

//     validateRows(rows) {
//       let firstInvalid = null;

//       this.clearGlobalError();

//       rows.forEach((row) => {
//         this.clearRowError(row);

//         const variantId =
//           row.dataset.variantId;

//         const available =
//           row.dataset.available ===
//           'true';

//         if (
//           !variantId ||
//           !available
//         ) {
//           this.showRowError(
//             row,
//             !variantId
//               ? 'Please choose an available variant.'
//               : 'This variant is sold out.'
//           );

//           if (!firstInvalid) {
//             firstInvalid = row;
//           }
//         }
//       });

//       rows.forEach((row) => {
//         const itemIndex =
//           this.getRowItemIndex(row);

//         const customItem =
//           this.getCustomizationItem(
//             itemIndex
//           );

//         if (!customItem) return;

//         this.clearRowFieldError(
//           customItem
//         );
//         this.clearRowImageError(
//           customItem
//         );

//         if (this.customEnabled) {
//           const value =
//             this.getCustomValueForIndex(
//               itemIndex
//             );

//           if (
//             this.customRequired &&
//             !value
//           ) {
//             this.showRowFieldError(
//               customItem,
//               this.dataset
//                 .fieldErrorMessage ||
//               'This field is required.'
//             );

//             if (!firstInvalid) {
//               firstInvalid = customItem;
//             }
//           } else {
//             const firstControl =
//               (this._customUi.get(customItem)?.fieldControls || [])
//                 .find((control) => control.type !== 'radio') ||
//               null;

//             if (
//               firstControl &&
//               typeof firstControl
//                 .checkValidity ===
//                 'function' &&
//               !firstControl
//                 .checkValidity()
//             ) {
//               this.showRowFieldError(
//                 customItem,
//                 firstControl
//                   .validationMessage ||
//                 this.dataset
//                   .fieldErrorMessage ||
//                 'Please check this field.'
//               );

//               if (!firstInvalid) {
//                 firstInvalid = customItem;
//               }
//             }
//           }
//         }

//         if (
//           this.customImageEnabled &&
//           this.customImageRequired
//         ) {
//           const photo =
//             this.getPhotoForIndex(
//               itemIndex
//             );

//           if (!this.isValidImage(photo)) {
//             this.showRowImageError(
//               customItem,
//               `${this.customImageRequiredMessage} Item #${itemIndex}`
//             );

//             if (!firstInvalid) {
//               firstInvalid = customItem;
//             }
//           }
//         }
//       });

//       if (!firstInvalid) {
//         return true;
//       }

//       this.showGlobalError(
//         this.dataset.atcErrorMessage ||
//         'Please complete all required fields.'
//       );

//       const focusTarget =
//         firstInvalid.querySelector(
//           '[data-pqcf-field-control], [data-pqcf-image-choose], [data-pqcf-option]'
//         );

//       if (focusTarget) {
//         focusTarget.focus();

//         firstInvalid.scrollIntoView({
//           behavior: 'smooth',
//           block: 'center'
//         });
//       }

//       return false;
//     }

//     createGroupId() {
//       if (
//         window.crypto &&
//         typeof window.crypto
//           .randomUUID ===
//           'function'
//       ) {
//         return (
//           'PQCF-' +
//           window.crypto
//             .randomUUID()
//         );
//       }

//       return (
//         'PQCF-' +
//         Date.now() +
//         '-' +
//         Math.random()
//           .toString(36)
//           .slice(2, 9)
//       );
//     }

//     buildMainItems(
//       rows,
//       groupId
//     ) {
//       return rows.map(
//         (
//           row,
//           index
//         ) => {
//           const properties = {
//             // Keep one private unique reference so Shopify does not merge
//             // personalized lines that otherwise have identical variants/properties.
//             // Format: <group-id>:<item-index>
//             _pqcf_ref:
//               `${groupId}:${index + 1}`
//           };

//           const itemIndex =
//             this.getRowItemIndex(
//               row
//             );

//           const customValue =
//             this.getCustomValueForIndex(
//               itemIndex
//             );

//           if (
//             this.customEnabled &&
//             customValue
//           ) {
//             properties[
//               this.propertyName
//             ] =
//               customValue;
//           }

//           return {
//             id:
//               Number(
//                 row.dataset.variantId
//               ),

//             quantity:
//               1,

//             properties
//           };
//         }
//       );
//     }

//     buildItems(rows) {
//       const groupId =
//         this.createGroupId();

//       return this.buildMainItems(
//         rows,
//         groupId
//       );
//     }

//     getExternalCustomizationBlock() {
//       const scopes = [
//         this.productInfo,
//         this.productFormElement,
//         this.form,
//         this.closest('.shopify-section')
//       ].filter(Boolean);

//       for (const scope of scopes) {
//         const candidates = Array.from(
//           scope.querySelectorAll(
//             'buy-buttons-custom-image[data-cibb-root], buy-buttons-custom-image'
//           )
//         );

//         if (!candidates.length) continue;

//         const exact = candidates.find((candidate) => {
//           const pqcfBlockId = String(
//             candidate.dataset?.pqcfBlockId || ''
//           ).trim();

//           return pqcfBlockId && pqcfBlockId === this.blockId;
//         });

//         if (exact) return exact;

//         const sameSection = candidates.find((candidate) =>
//           String(candidate.dataset?.sectionId || '') === this.sectionId
//         );

//         if (sameSection) return sameSection;

//         return candidates[0];
//       }

//       return null;
//     }

//     prepareExternalCustomization(rows) {
//       // PQCF's own Theme Editor toggles are the source of truth.
//       // Do not fall back to any legacy/external customization block when
//       // Custom Image is disabled; doing so can make OFF toggles still validate
//       // or add external Name/Photo properties.
//       const items = this.buildItems(rows);

//       if (!this.customImageEnabled) {
//         return {
//           customBlock: null,
//           payload: {
//             source: 'internal-pqcf',
//             quantity: rows.length
//           },
//           items,
//           files: new Map(),
//           photoPropertyName: this.customImagePropertyName,
//           hasFiles: false,
//           invalid: false
//         };
//       }

//       const files = new Map();

//       rows.forEach((row, rowIndex) => {
//         const itemIndex =
//           this.getRowItemIndex(row);

//         const file =
//           this.getPhotoForIndex(itemIndex);

//         if (file) {
//           files.set(rowIndex, file);
//         }
//       });

//       return {
//         customBlock: null,
//         payload: {
//           source: 'internal-pqcf',
//           quantity: rows.length,
//           customImagePropertyName:
//             this.customImagePropertyName
//         },
//         items,
//         files,
//         photoPropertyName:
//           this.customImagePropertyName,
//         hasFiles: files.size > 0,
//         invalid: false
//       };
//     }

//     async parseCartResponse(response) {
//       let data = {};

//       try {
//         data = await response.json();
//       } catch (_) {}

//       if (!response.ok) {
//         let message =
//           data?.description ||
//           data?.message ||
//           '';

//         if (!message && data?.errors) {
//           if (typeof data.errors === 'string') {
//             message = data.errors;
//           } else if (typeof data.errors === 'object') {
//             message = Object.entries(data.errors)
//               .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : String(value)}`)
//               .join(' | ');
//           }
//         }

//         throw new Error(
//           message ||
//           `Unable to add these items to cart. (${response.status})`
//         );
//       }

//       return data;
//     }

//     async rollbackAddedCartLines(responses) {
//       const keys = (responses || [])
//         .map((entry) => entry?.key)
//         .filter(Boolean)
//         .reverse();

//       if (!keys.length) return;

//       for (const key of keys) {
//         try {
//           await fetch(
//             window.Shopify?.routes?.root
//               ? `${window.Shopify.routes.root}cart/change.js`
//               : '/cart/change.js',
//             {
//               method: 'POST',
//               headers: {
//                 'Content-Type': 'application/json',
//                 Accept: 'application/json',
//                 'X-Requested-With': 'XMLHttpRequest'
//               },
//               body: JSON.stringify({
//                 id: key,
//                 quantity: 0
//               })
//             }
//           );
//         } catch (_) {}
//       }
//     }

//     getCartAddUrl() {
//       return (
//         window.routes?.cart_add_url ||
//         (
//           window.Shopify?.routes?.root
//             ? `${window.Shopify.routes.root}cart/add.js`
//             : '/cart/add.js'
//         )
//       );
//     }

//     getBundledSectionRequest() {
//       return {
//         sections: [
//           'cart-drawer',
//           'cart-icon-bubble'
//         ],
//         sections_url:
//           window.location.pathname || '/'
//       };
//     }

//     hasUsableBundledSections(cartData) {
//       const sections = cartData?.sections;

//       if (!sections || typeof sections !== 'object') {
//         return false;
//       }

//       return [
//         'cart-drawer',
//         'cart-icon-bubble'
//       ].every(
//         (sectionId) =>
//           typeof sections[sectionId] === 'string'
//       );
//     }

//     getBundledCartData(addData) {
//       if (Array.isArray(addData)) {
//         return addData[addData.length - 1] || null;
//       }

//       return addData || null;
//     }

//     renderShrineCart(cartData) {
//       const drawer =
//         this.getCartDrawer();

//       if (
//         !drawer ||
//         typeof drawer
//           .renderContents !==
//           'function'
//       ) {
//         return false;
//       }

//       drawer.renderContents(
//         cartData
//       );

//       let drawerEl =
//         this._cartDrawerEl;

//       if (!drawerEl?.isConnected) {
//         drawerEl = drawer.matches?.('cart-drawer.drawer')
//           ? drawer
//           : document.querySelector('cart-drawer.drawer');
//         this._cartDrawerEl = drawerEl || null;
//       }

//       if (drawerEl?.classList.contains('is-empty')) {
//         drawerEl.classList.remove('is-empty');
//       }

//       return true;
//     }

//     async addJsonItemsToCart(items) {
//       const response = await fetch(
//         this.getCartAddUrl(),
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             Accept: 'application/json',
//             'X-Requested-With': 'XMLHttpRequest'
//           },
//           body: JSON.stringify({
//             items,
//             ...this.getBundledSectionRequest()
//           })
//         }
//       );

//       return this.parseCartResponse(response);
//     }

//     appendPropertiesToFormData(formData, properties) {
//       Object.entries(properties || {}).forEach(([key, value]) => {
//         if (
//           value === null ||
//           typeof value === 'undefined' ||
//           String(value) === ''
//         ) {
//           return;
//         }

//         formData.append(
//           `properties[${key}]`,
//           String(value)
//         );
//       });
//     }

//     async addFormDataItemsToCart(
//       items,
//       files,
//       photoPropertyName
//     ) {
//       const responses = [];
//       const addUrl =
//         this.getCartAddUrl();

//       const startedAt =
//         typeof performance !== 'undefined'
//           ? performance.now()
//           : Date.now();

//       try {
//         for (let index = 0; index < items.length; index += 1) {
//           const item = items[index];
//           const formData = new FormData();
//           const itemStartedAt =
//             typeof performance !== 'undefined'
//               ? performance.now()
//               : Date.now();

//           formData.append('id', String(item.id));
//           formData.append(
//             'quantity',
//             String(item.quantity || 1)
//           );

//           this.appendPropertiesToFormData(
//             formData,
//             item.properties
//           );

//           const file = files.get(index);

//           if (file) {
//             formData.append(
//               `properties[${photoPropertyName}]`,
//               file,
//               file.name || `photo-${index + 1}`
//             );
//           }

//           // File line-item properties require multipart FormData. Keep cart
//           // mutations sequential for stability, but request rendered sections
//           // only on the final mutation so the earlier uploads stay lightweight.
//           if (index === items.length - 1) {
//             const sectionRequest =
//               this.getBundledSectionRequest();

//             formData.append(
//               'sections',
//               sectionRequest.sections.join(',')
//             );
//             formData.append(
//               'sections_url',
//               sectionRequest.sections_url
//             );
//           }

//           this.debug('upload item start', {
//             item: index + 1,
//             total: items.length,
//             variantId: item.id,
//             hasFile: !!file,
//             fileSize: file?.size || 0,
//             fileType: file?.type || ''
//           });

//           const response = await fetch(addUrl, {
//             method: 'POST',
//             headers: {
//               Accept: 'application/json',
//               'X-Requested-With': 'XMLHttpRequest'
//             },
//             body: formData
//           });

//           const parsed =
//             await this.parseCartResponse(response);

//           responses.push(parsed);

//           const itemEndedAt =
//             typeof performance !== 'undefined'
//               ? performance.now()
//               : Date.now();

//           this.debug('upload item complete', {
//             item: index + 1,
//             total: items.length,
//             durationMs: Math.round(itemEndedAt - itemStartedAt)
//           });
//         }
//       } catch (error) {
//         this.debug('upload failed; rolling back', {
//           completed: responses.length,
//           message: error?.message || String(error)
//         });
//         await this.rollbackAddedCartLines(responses);
//         throw error;
//       }

//       const endedAt =
//         typeof performance !== 'undefined'
//           ? performance.now()
//           : Date.now();

//       this.debug('all file uploads complete', {
//         itemCount: items.length,
//         durationMs: Math.round(endedAt - startedAt)
//       });

//       return responses;
//     }

//     getSelectedQuantity() {
//       const offer =
//         this.getActiveOffer();

//       return Math.max(
//         0,
//         Number(
//           offer?.dataset.quantity ||
//           0
//         )
//       );
//     }

//     /*
//      * Both Product and Free Shipping cards
//      * use the same threshold system.
//      *
//      * Free Shipping does NOT require
//      * inventory or a variant ID.
//      */
//     updateGiftStates() {
//       if (
//         !this.showGifts ||
//         !this.gifts.length
//       ) {
//         return;
//       }

//       const quantity =
//         this.getSelectedQuantity();

//       this.gifts.forEach(
//         (gift) => {
//           const type =
//             gift.dataset.giftType ||
//             'product';

//           const threshold =
//             Math.max(
//               1,
//               Number(
//                 gift.dataset
//                   .unlockQuantity ||
//                 1
//               )
//             );

//           const available =
//             type === 'free_shipping'
//               ? true
//               : gift.dataset
//                   .available ===
//                 'true';

//           const unlocked =
//             available &&
//             quantity >=
//             threshold;

//           gift.dataset.unlocked =
//             unlocked
//               ? 'true'
//               : 'false';

//           gift.classList.toggle(
//             'pqcf__gift--unlocked',
//             unlocked
//           );

//           gift.classList.toggle(
//             'pqcf__gift--locked',
//             !unlocked
//           );

//           gift.classList.toggle(
//             'pqcf__gift--unavailable',
//             !available
//           );

//           const lock =
//             this._giftLocks.get(gift) ||
//             null;

//           if (lock) {
//             lock.hidden =
//               unlocked;
//           }
//         }
//       );
//     }

//     syncDefaultAtcPrice(cents) {
//       const holder =
//         document.getElementById(
//           `main-atc-price-${this.sectionId}`
//         );

//       if (!holder) return;

//       const priceSpan =
//         holder.querySelector(
//           '[class*="main-atc-price-span-"]'
//         );

//       if (priceSpan) {
//         priceSpan.textContent =
//           this.formatMoney(
//             cents
//           );
//       }
//     }

//     applyAlternativeButtonPolicy() {
//       if (!this.productFormElement) {
//         return;
//       }

//       this.productFormElement
//         .classList
//         .add(
//           'pqcf-product-form--active'
//         );

//       if (
//         this.hideAlternativeButtons
//       ) {
//         this.productFormElement
//           .classList
//           .add(
//             'pqcf-product-form--hide-alt'
//           );
//       }
//     }

//     removeAlternativeButtonPolicy() {
//       if (!this.productFormElement) {
//         return;
//       }

//       this.productFormElement
//         .classList
//         .remove(
//           'pqcf-product-form--active',
//           'pqcf-product-form--hide-alt'
//         );
//     }

//     onProductAreaClickCapture(
//       event
//     ) {
//       const mainButton =
//         event.target.closest(
//           `#ProductSubmitButton-${CSS.escape(
//             this.sectionId
//           )}`
//         );

//       const secondaryButton =
//         event.target.closest(
//           `#SectionAtcBtn-${CSS.escape(
//             this.sectionId
//           )}`
//         );

//       if (
//         !mainButton &&
//         !secondaryButton
//       ) {
//         return;
//       }

//       event.preventDefault();
//       event.stopImmediatePropagation();

//       if (this.isSubmitting) {
//         return;
//       }

//       this.submitBundle(
//         mainButton ||
//         secondaryButton
//       );
//     }

//     onProductAreaSubmitCapture(
//       event
//     ) {
//       if (
//         !this.isRelevantForm(
//           event.target
//         )
//       ) {
//         return;
//       }

//       event.preventDefault();
//       event.stopImmediatePropagation();

//       if (this.isSubmitting) {
//         return;
//       }

//       this.submitBundle(
//         event.submitter ||
//         this.mainButton
//       );
//     }

//     isRelevantForm(form) {
//       return (
//         !!form &&
//         form.id ===
//           this.productFormId
//       );
//     }

//     async submitBundle(
//       triggerButton
//     ) {
//       if (this.isSubmitting) {
//         return;
//       }

//       const submitStartedAt =
//         typeof performance !== 'undefined'
//           ? performance.now()
//           : Date.now();

//       const rows = this.getActiveRows();

//       if (!rows.length) {
//         this.showGlobalError(
//           'Please select an offer.'
//         );

//         return;
//       }

//       if (!this.validateRows(rows)) {
//         return;
//       }

//       const prepared =
//         this.prepareExternalCustomization(
//           rows
//         );

//       if (prepared.invalid) {
//         this.showGlobalError(
//           'Please complete all required personalization and photo fields.'
//         );

//         return;
//       }

//       const items = prepared.items;

//       const invalidItem = items.find((item) => {
//         const id = Number(item.id);
//         return !id || !this.variantMap.has(String(id));
//       });

//       if (
//         !items.length ||
//         invalidItem
//       ) {
//         this.showGlobalError(
//           'Unable to build the selected items.'
//         );

//         return;
//       }

//       this.isSubmitting = true;

//       this.setLoading(
//         triggerButton,
//         true
//       );

//       this.clearButtonError(
//         triggerButton
//       );

//       this.clearGlobalError();

//       this.debug(
//         'cart payload',
//         {
//           itemCount: items.length,
//           items,
//           customizationSource:
//             prepared.payload?.source ||
//             (prepared.customBlock ? 'external-block' : 'pqcf'),
//           hasFiles: prepared.hasFiles,
//           photoPropertyName:
//             prepared.photoPropertyName
//         }
//       );

//       try {
//         const addData = prepared.hasFiles
//           ? await this.addFormDataItemsToCart(
//               items,
//               prepared.files,
//               prepared.photoPropertyName
//             )
//           : await this.addJsonItemsToCart(
//               items
//             );

//         this.debug(
//           'add success',
//           addData
//         );

//         const bundledCartData =
//           this.getBundledCartData(
//             addData
//           );

//         let cartData =
//           bundledCartData;

//         let renderedFromAdd =
//           false;

//         if (
//           this.hasUsableBundledSections(
//             bundledCartData
//           )
//         ) {
//           try {
//             renderedFromAdd =
//               this.renderShrineCart(
//                 bundledCartData
//               );
//           } catch (renderError) {
//             this.debug(
//               'bundled cart render failed; using refresh fallback',
//               renderError
//             );
//           }
//         }

//         // Safety fallback: preserve the old Shrine refresh behavior if the
//         // bundled sections are missing, null, or the theme cannot render them.
//         if (!renderedFromAdd) {
//           cartData =
//             await this.refreshShrineCart();

//           this.debug(
//             'cart refreshed via fallback',
//             cartData
//           );
//         } else {
//           this.debug(
//             'cart rendered from bundled add response',
//             cartData
//           );
//         }

//         this.dispatchEvent(
//           new CustomEvent(
//             'pqcf:added',
//             {
//               bubbles: true,
//               detail: {
//                 items,
//                 response: addData,
//                 cart: cartData,
//                 customization:
//                   prepared.payload || null
//               }
//             }
//           )
//         );
//       } catch (error) {
//         console.error(
//           '[PQCF] Add to cart failed',
//           error
//         );

//         this.showButtonError(
//           triggerButton,
//           error.message ||
//           'Unable to add to cart.'
//         );

//         this.showGlobalError(
//           error.message ||
//           'Unable to add to cart.'
//         );
//       } finally {
//         const submitEndedAt =
//           typeof performance !== 'undefined'
//             ? performance.now()
//             : Date.now();

//         this.debug('add-to-cart total', {
//           durationMs: Math.round(submitEndedAt - submitStartedAt),
//           rowCount: rows.length,
//           hasFiles: prepared.hasFiles
//         });

//         this.isSubmitting = false;

//         this.setLoading(
//           triggerButton,
//           false
//         );
//       }
//     }

//     async refreshShrineCart() {
//       const response =
//         await fetch(
//           '/cart/update.js',
//           {
//             method:
//               'POST',

//             headers: {
//               'Content-Type':
//                 'application/json',

//               Accept:
//                 'application/json',

//               'X-Requested-With':
//                 'XMLHttpRequest'
//             },

//             body:
//               JSON.stringify({
//                 updates: {},

//                 sections: [
//                   'cart-drawer',
//                   'cart-icon-bubble'
//                 ],

//                 sections_url:
//                   window.location.pathname
//               })
//           }
//         );

//       let cartData =
//         {};

//       try {
//         cartData =
//           await response.json();
//       } catch (_) {}

//       if (!response.ok) {
//         throw new Error(
//           cartData?.description ||
//           cartData?.message ||
//           'Unable to refresh cart.'
//         );
//       }

//       this.renderShrineCart(
//         cartData
//       );

//       return cartData;
//     }

//     onExternalChange(event) {
//       if (
//         this.enableVariantSelectors ||
//         this.contains(
//           event.target
//         )
//       ) {
//         return;
//       }

//       const productInfo =
//         event.target.closest(
//           `#ProductInfo-${CSS.escape(
//             this.sectionId
//           )}`
//         );

//       if (!productInfo) {
//         return;
//       }

//       window.setTimeout(
//         () =>
//           this.syncRowsToMainVariant(),
//         0
//       );
//     }

//     syncRowsToMainVariant() {
//       if (
//         this.enableVariantSelectors ||
//         !this.form
//       ) {
//         return;
//       }

//       const idInput =
//         this.form.querySelector(
//           'input[name="id"]'
//         );

//       if (!idInput?.value) {
//         return;
//       }

//       const variant =
//         this.variantMap.get(
//           String(
//             idInput.value
//           )
//         );

//       if (!variant) {
//         return;
//       }

//       this.offers.forEach((offer) => {
//         this.getOfferRows(offer).forEach((row) => {
//           this.applyVariantToRow(
//             row,
//             variant,
//             false
//           );
//         });
//       });

//       this.refreshAllOfferPrices();
//     }

//     setLoading(
//       button,
//       loading
//     ) {
//       const target =
//         button ||
//         this.mainButton;

//       if (!target) return;

//       if (loading) {
//         target.dataset
//           .pqcfWasDisabled =
//           target.disabled
//             ? 'true'
//             : 'false';

//         target.disabled =
//           true;
//       } else if (
//         target.dataset
//           .pqcfWasDisabled !==
//         'true'
//       ) {
//         target.disabled =
//           false;
//       }

//       target.classList.toggle(
//         'loading',
//         loading
//       );

//       target.setAttribute(
//         'aria-busy',
//         loading
//           ? 'true'
//           : 'false'
//       );

//       const spinner =
//         target.querySelector(
//           '.loading-overlay__spinner'
//         );

//       if (spinner) {
//         spinner.classList.toggle(
//           'hidden',
//           !loading
//         );
//       }

//       if (!loading) {
//         delete target.dataset
//           .pqcfWasDisabled;
//       }
//     }

//     showButtonError(
//       button,
//       message
//     ) {
//       const target =
//         button ||
//         this.mainButton;

//       const error =
//         target?.querySelector(
//           '.main-atc__error'
//         );

//       if (!error) return;

//       error.textContent =
//         message;

//       error.style.display =
//         '';
//     }

//     clearButtonError(button) {
//       const target =
//         button ||
//         this.mainButton;

//       const error =
//         target?.querySelector(
//           '.main-atc__error'
//         );

//       if (!error) return;

//       error.textContent = '';
//       error.style.display =
//         'none';
//     }

//     showRowFieldError(
//       row,
//       message
//     ) {
//       row.classList.add(
//         'pqcf__item--error'
//       );

//       const error =
//         this._customUi.get(row)?.fieldError ||
//         row.querySelector('[data-pqcf-field-error]');

//       if (error) {
//         error.textContent =
//           message;

//         error.hidden =
//           false;
//       }
//     }

//     clearRowFieldError(row) {
//       row.classList.remove(
//         'pqcf__item--error'
//       );

//       const error =
//         this._customUi.get(row)?.fieldError ||
//         row.querySelector('[data-pqcf-field-error]');

//       if (error) {
//         error.hidden =
//           true;
//       }
//     }

//     showRowError(
//       row,
//       message
//     ) {
//       const error =
//         row.querySelector(
//           '[data-pqcf-row-error]'
//         );

//       if (error) {
//         error.textContent =
//           message;

//         error.hidden =
//           false;
//       }
//     }

//     clearRowError(row) {
//       const error =
//         row.querySelector(
//           '[data-pqcf-row-error]'
//         );

//       if (error) {
//         error.hidden =
//           true;
//       }
//     }

//     showGlobalError(message) {
//       const error =
//         this.querySelector(
//           '[data-pqcf-global-error]'
//         );

//       if (!error) return;

//       error.textContent =
//         message;

//       error.hidden =
//         false;
//     }

//     clearGlobalError() {
//       const error =
//         this.querySelector(
//           '[data-pqcf-global-error]'
//         );

//       if (!error) return;

//       error.textContent = '';
//       error.hidden = true;
//     }

//     debug(
//       message,
//       data
//     ) {
//       if (!this.debugEnabled) {
//         return;
//       }

//       if (
//         typeof data ===
//         'undefined'
//       ) {
//         console.log(
//           `[PQCF] ${message}`
//         );
//       } else {
//         console.log(
//           `[PQCF] ${message}`,
//           data
//         );
//       }
//     }
//   }

//   customElements.define(
//     TAG,
//     ProductQuantityCustomFields
//   );
// })();




(() => {
  const TAG = 'product-quantity-custom-fields';

  if (customElements.get(TAG)) return;

  class ProductQuantityCustomFields extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId || '';
      this.blockId = this.dataset.blockId || '';
      this.productFormId = this.dataset.productFormId || '';

      this.enableVariantSelectors =
        this.dataset.enableVariantSelectors === 'true';

      this.customEnabled =
        (this.dataset.nameEnabled ?? this.dataset.customEnabled) === 'true';

      this.customRequired =
        this.dataset.customRequired === 'true';

      this.propertyName =
        (this.dataset.propertyName || 'Name').trim() || 'Name';

      this.customImageEnabled =
        this.dataset.customImageEnabled === 'true';

      this.customImageRequired =
        this.dataset.customImageRequired === 'true';

      this.customImagePropertyName =
        (this.dataset.customImagePropertyName || 'Custom Image').trim() || 'Custom Image';

      this.customImageRequiredMessage =
        (this.dataset.customImageRequiredMessage || 'Please add a photo.').trim() || 'Please add a photo.';

      this.photosByIndex = new Map();

      this.showGifts =
        this.dataset.showGifts === 'true';

      this.hideAlternativeButtons =
        this.dataset.hideAlternativeButtons === 'true';

      this.debugEnabled =
        this.dataset.debug === 'true';

      this.isSubmitting = false;

      this.bound = {};
      this._interceptorTarget = null;

      // Performance caches. The PQCF DOM is static for the lifetime of this
      // custom element, so cache hot-path lookups and rebuild them whenever
      // Shopify recreates the section/component.
      this._offerRows = new WeakMap();
      this._rowControls = new WeakMap();
      this._rowOptions = new WeakMap();
      this._offerUi = new WeakMap();
      this._giftLocks = new WeakMap();
      this._customItems = [];
      this._customItemMap = new Map();
      this._customUi = new WeakMap();
      this._customPanel = null;
      this._activeOffer = null;
      this._cartDrawer = null;
      this._cartDrawerEl = null;
      this.variantOptionsMap = new Map();
      this._selectOptionCatalog = new WeakMap();
    }

    connectedCallback() {
      if (this.dataset.pqcfInitialized === 'true') {
        return;
      }

      this.dataset.pqcfInitialized = 'true';

      this.variants = this.readVariants();

      this.variantMap = new Map(
        this.variants.map((variant) => [
          String(variant.id),
          variant
        ])
      );

      this.variantOptionsMap = new Map();
      this._selectOptionCatalog = new WeakMap();
      this.variantPrefixMap = new Map();
      this.variantValueMap = new Map();

      this.variants.forEach((variant) => {
        if (!Array.isArray(variant.options)) return;

        const key =
          this.makeVariantOptionsKey(variant.options);

        // Keep Shopify order deterministic if duplicate combinations ever exist.
        if (!this.variantOptionsMap.has(key)) {
          this.variantOptionsMap.set(key, variant);
        }

        for (let index = 0; index < variant.options.length; index += 1) {
          const valueKey =
            this.makeVariantValueKey(index, variant.options[index]);

          if (!this.variantValueMap.has(valueKey)) {
            this.variantValueMap.set(valueKey, []);
          }

          this.variantValueMap.get(valueKey).push(variant);

          const prefixKey =
            this.makeVariantPrefixKey(
              variant.options,
              index + 1
            );

          if (!this.variantPrefixMap.has(prefixKey)) {
            this.variantPrefixMap.set(prefixKey, []);
          }

          this.variantPrefixMap.get(prefixKey).push(variant);
        }
      });

      this.offers = Array.from(
        this.querySelectorAll('[data-pqcf-offer]')
      );

      this.gifts = Array.from(
        this.querySelectorAll('[data-pqcf-gift]')
      );

      this.cacheStaticDom();
      this.resolveThemeElements();

      this.bound.onRootChange =
        this.onRootChange.bind(this);

      this.bound.onRootClick =
        this.onRootClick.bind(this);

      this.bound.onProductAreaClickCapture =
        this.onProductAreaClickCapture.bind(this);

      this.bound.onProductAreaSubmitCapture =
        this.onProductAreaSubmitCapture.bind(this);

      this.bound.onExternalChange =
        this.onExternalChange.bind(this);

      this.addEventListener(
        'change',
        this.bound.onRootChange
      );

      this.addEventListener(
        'input',
        this.bound.onRootChange
      );

      this.addEventListener(
        'click',
        this.bound.onRootClick
      );

      this.bindThemeInterceptors();

      if (this.productInfo) {
        this.productInfo.addEventListener(
          'change',
          this.bound.onExternalChange,
          true
        );
      }

      this.initializeRows();
      this.ensureActiveOffer();
      this.refreshAllOfferPrices();
      this.updateGiftStates();
      this.updateCustomizationVisibility();
      this.refreshPhotoUIs();
      this.applyAlternativeButtonPolicy();

      requestAnimationFrame(() => {
        this.resolveThemeElements();
        this.bindThemeInterceptors();
        this.applyAlternativeButtonPolicy();
      });

      this.debug('initialized', {
        form: this.form,
        mainButton: this.mainButton,
        productFormElement: this.productFormElement,
        productInfo: this.productInfo
      });
    }

    disconnectedCallback() {
      this.removeEventListener(
        'change',
        this.bound.onRootChange
      );

      this.removeEventListener(
        'input',
        this.bound.onRootChange
      );

      this.removeEventListener(
        'click',
        this.bound.onRootClick
      );

      this.photosByIndex.forEach((record) => {
        if (record?.previewUrl) {
          URL.revokeObjectURL(record.previewUrl);
        }
      });
      this.photosByIndex.clear();

      this.unbindThemeInterceptors();

      if (this.productInfo) {
        this.productInfo.removeEventListener(
          'change',
          this.bound.onExternalChange,
          true
        );
      }

      this.removeAlternativeButtonPolicy();

      this._customItems = [];
      this._customItemMap.clear();
      this._activeOffer = null;
      this._cartDrawer = null;
      this._cartDrawerEl = null;

      this.dataset.pqcfInitialized = 'false';
    }

    makeVariantOptionsKey(options) {
      return (options || [])
        .map((value) => String(value))
        .join('\u001f');
    }

    makeVariantPrefixKey(options, length) {
      const safeLength = Math.max(0, Number(length) || 0);
      return `${safeLength}\u001e${this.makeVariantOptionsKey(
        (options || []).slice(0, safeLength)
      )}`;
    }

    makeVariantValueKey(index, value) {
      return `${Number(index) || 0}\u001e${String(value)}`;
    }

    cacheStaticDom() {
      this._offerRows = new WeakMap();
      this._rowControls = new WeakMap();
      this._rowOptions = new WeakMap();
      this._offerUi = new WeakMap();
      this._giftLocks = new WeakMap();
      this._customUi = new WeakMap();

      this.offers.forEach((offer) => {
        const rows = Array.from(
          offer.querySelectorAll('[data-pqcf-item]')
        ).sort(
          (a, b) =>
            Number(a.dataset.itemIndex || 0) -
            Number(b.dataset.itemIndex || 0)
        );

        this._offerRows.set(offer, rows);

        rows.forEach((row) => {
          this._rowControls.set(
            row,
            Array.from(
              row.querySelectorAll(
                '[data-pqcf-option], [data-pqcf-field-control], [data-pqcf-image-input], [data-pqcf-image-choose], [data-pqcf-image-change], [data-pqcf-image-remove]'
              )
            )
          );

          this._rowOptions.set(
            row,
            Array.from(
              row.querySelectorAll('[data-pqcf-option]')
            ).sort(
              (a, b) =>
                Number(a.dataset.optionPosition) -
                Number(b.dataset.optionPosition)
            )
          );

          this._rowOptions.get(row).forEach((select) => {
            if (!this._selectOptionCatalog.has(select)) {
              this._selectOptionCatalog.set(
                select,
                Array.from(select.options).map((option) => ({
                  value: String(option.value),
                  label: option.textContent || option.label || String(option.value)
                }))
              );
            }
          });
        });

        this._offerUi.set(offer, {
          price: offer.querySelector('[data-pqcf-price]'),
          compare: offer.querySelector('[data-pqcf-compare-price]'),
          label: offer.querySelector('[data-pqcf-label]'),
          caption: offer.querySelector('[data-pqcf-caption]'),
          savings: offer.querySelector('[data-pqcf-savings]')
        });
      });

      this._customPanel =
        this.querySelector('[data-pqcf-custom-panel]');

      this._customItems = Array.from(
        this.querySelectorAll('[data-pqcf-custom-item]')
      ).sort(
        (a, b) =>
          this.getCustomizationItemIndex(a) -
          this.getCustomizationItemIndex(b)
      );

      this._customItemMap = new Map(
        this._customItems.map((item) => [
          this.getCustomizationItemIndex(item),
          item
        ])
      );

      this._customItems.forEach((item) => {
        this._customUi.set(item, {
          fieldControls: Array.from(
            item.querySelectorAll('[data-pqcf-field-control]')
          ),
          allControls: Array.from(
            item.querySelectorAll(
              '[data-pqcf-field-control], [data-pqcf-image-input], [data-pqcf-image-choose], [data-pqcf-image-change], [data-pqcf-image-remove]'
            )
          ),
          empty: item.querySelector('[data-pqcf-image-empty]'),
          preview: item.querySelector('[data-pqcf-image-preview]'),
          image: item.querySelector('[data-pqcf-image-preview-img]'),
          filename: item.querySelector('[data-pqcf-image-filename]'),
          input: item.querySelector('[data-pqcf-image-input]'),
          choose: item.querySelector('[data-pqcf-image-choose]'),
          fieldError: item.querySelector('[data-pqcf-field-error]'),
          imageError: item.querySelector('[data-pqcf-image-error]')
        });
      });

      this.gifts.forEach((gift) => {
        this._giftLocks.set(
          gift,
          gift.querySelector('[data-pqcf-gift-lock]')
        );
      });
    }

    getOfferRows(offer) {
      if (!offer) return [];

      const cached = this._offerRows.get(offer);
      if (cached) return cached;

      const rows = Array.from(
        offer.querySelectorAll('[data-pqcf-item]')
      ).sort(
        (a, b) =>
          Number(a.dataset.itemIndex || 0) -
          Number(b.dataset.itemIndex || 0)
      );

      this._offerRows.set(offer, rows);
      return rows;
    }

    getCartDrawer() {
      if (this._cartDrawer?.isConnected) {
        return this._cartDrawer;
      }

      this._cartDrawer = document.querySelector('cart-drawer');
      return this._cartDrawer;
    }

    resolveThemeElements() {
      this.form =
        document.getElementById(
          this.productFormId
        );

      this.productFormElement =
        document.getElementById(
          `ProductForm-${this.sectionId}`
        );

      this.mainButton =
        document.getElementById(
          `ProductSubmitButton-${this.sectionId}`
        );

      this.secondaryButton =
        document.getElementById(
          `SectionAtcBtn-${this.sectionId}`
        );

      this.productInfo =
        document.getElementById(
          `ProductInfo-${this.sectionId}`
        );
    }
        bindThemeInterceptors() {
      if (this._interceptorTarget) {
        return;
      }

      const target =
        this.productInfo ||
        this.productFormElement ||
        this.form;

      if (!target) {
        this.debug(
          'No theme interception target found yet.'
        );

        return;
      }

      target.addEventListener(
        'click',
        this.bound.onProductAreaClickCapture,
        true
      );

      target.addEventListener(
        'submit',
        this.bound.onProductAreaSubmitCapture,
        true
      );

      this._interceptorTarget = target;
    }

    unbindThemeInterceptors() {
      if (!this._interceptorTarget) {
        return;
      }

      this._interceptorTarget.removeEventListener(
        'click',
        this.bound.onProductAreaClickCapture,
        true
      );

      this._interceptorTarget.removeEventListener(
        'submit',
        this.bound.onProductAreaSubmitCapture,
        true
      );

      this._interceptorTarget = null;
    }

    readVariants() {
      const script =
        this.querySelector(
          '[data-pqcf-variants]'
        );

      if (!script) {
        return [];
      }

      try {
        const variants =
          JSON.parse(
            script.textContent || '[]'
          );

        return Array.isArray(variants)
          ? variants
          : [];
      } catch (error) {
        console.error(
          '[PQCF] Invalid variants JSON',
          error
        );

        return [];
      }
    }

    initializeRows() {
      this.offers.forEach((offer) => {
        this.getOfferRows(offer).forEach((row) => {
          if (this.enableVariantSelectors) {
            this.resolveRowVariant(
              row,
              false
            );
          } else {
            const variant =
              this.variantMap.get(
                String(
                  row.dataset.variantId
                )
              );

            if (variant) {
              this.applyVariantToRow(
                row,
                variant,
                false
              );
            }
          }
        });
      });
    }

    ensureActiveOffer() {
      let radio =
        this.querySelector(
          '[data-pqcf-offer-radio]:checked'
        );

      if (!radio) {
        radio =
          this.querySelector(
            '[data-pqcf-offer-radio]'
          );

        if (radio) {
          radio.checked = true;
        }
      }

      if (radio) {
        this.activateOffer(
          radio.closest(
            '[data-pqcf-offer]'
          )
        );
      }
    }

    onRootChange(event) {
      // Selects, offer radios and file inputs commonly emit both `input` and
      // `change`. Process those controls only on `change` so one user action
      // cannot resolve variants twice or create/revoke the same photo preview
      // URL twice. Text/personalization controls may continue using `input` for
      // immediate error clearing.
      if (
        event.type === 'input' &&
        event.target.matches(
          '[data-pqcf-option], [data-pqcf-offer-radio], [data-pqcf-image-input]'
        )
      ) {
        return;
      }

      const radio =
        event.target.closest(
          '[data-pqcf-offer-radio]'
        );

      if (
        radio &&
        this.contains(radio)
      ) {
        this.activateOffer(
          radio.closest(
            '[data-pqcf-offer]'
          )
        );

        return;
      }

      const customItem =
        event.target.closest(
          '[data-pqcf-custom-item]'
        );

      if (
        customItem &&
        this.contains(customItem)
      ) {
        if (
          event.target.matches(
            '[data-pqcf-image-input]'
          )
        ) {
          const itemIndex =
            this.getCustomizationItemIndex(
              customItem
            );

          const file =
            event.target.files?.[0] ||
            null;

          if (file) {
            this.setPhoto(
              itemIndex,
              file
            );
          }

          return;
        }

        if (
          event.target.matches(
            '[data-pqcf-field-control]'
          )
        ) {
          this.clearRowFieldError(
            customItem
          );
          this.clearGlobalError();
        }

        return;
      }

      const row =
        event.target.closest(
          '[data-pqcf-item]'
        );

      if (
        !row ||
        !this.contains(row)
      ) {
        return;
      }

      if (
        event.target.matches(
          '[data-pqcf-option]'
        )
      ) {
        const changedOptionIndex =
          Math.max(
            0,
            Number(event.target.dataset.optionPosition || 1) - 1
          );

        const variantStartedAt =
          this.debugEnabled
            ? (typeof performance !== 'undefined'
                ? performance.now()
                : Date.now())
            : 0;

        this.resolveRowVariant(
          row,
          true,
          changedOptionIndex
        );

        if (this.debugEnabled) {
          const variantEndedAt =
            typeof performance !== 'undefined'
              ? performance.now()
              : Date.now();

          this.debug('variant resolve performance', {
            itemIndex: row.dataset.itemIndex,
            changedOptionIndex,
            durationMs: Math.round((variantEndedAt - variantStartedAt) * 100) / 100
          });
        }

        this.updateOfferPrice(
          row.closest(
            '[data-pqcf-offer]'
          )
        );
      }
    }

    onRootClick(event) {
      const button =
        event.target.closest?.(
          '[data-pqcf-image-choose], [data-pqcf-image-change], [data-pqcf-image-remove]'
        );

      if (
        !button ||
        !this.contains(button)
      ) {
        return;
      }

      const customItem =
        button.closest(
          '[data-pqcf-custom-item]'
        );

      if (!customItem) return;

      event.preventDefault();

      const itemIndex =
        this.getCustomizationItemIndex(
          customItem
        );

      if (
        button.matches(
          '[data-pqcf-image-remove]'
        )
      ) {
        this.removePhoto(
          itemIndex
        );

        return;
      }

      const imageInput =
        this._customUi.get(customItem)?.input ||
        customItem.querySelector('[data-pqcf-image-input]');

      imageInput?.click();
    }

    activateOffer(activeOffer) {
      if (!activeOffer) return;

      this._activeOffer = activeOffer;

      this.offers.forEach((offer) => {
        const active =
          offer === activeOffer;

        offer.classList.toggle(
          'pqcf__offer--selected',
          active
        );

        offer.dataset.active =
          active ? 'true' : 'false';

        this.getOfferRows(offer).forEach((row) => {
          row.dataset.active =
            active ? 'true' : 'false';

          this.setRowControlsDisabled(
            row,
            !active
          );

          if (!active) {
            this.clearRowFieldError(row);
            this.clearRowImageError(row);
            this.clearRowError(row);
          }
        });
      });

      this.clearGlobalError();

      this.updateOfferPrice(
        activeOffer
      );

      this.updateGiftStates();
      this.updateCustomizationVisibility();
      this.refreshPhotoUIs();
    }

    setRowControlsDisabled(
      row,
      disabled
    ) {
      const controls =
        this._rowControls.get(row) ||
        Array.from(
          row.querySelectorAll(
            '[data-pqcf-option], [data-pqcf-field-control], [data-pqcf-image-input], [data-pqcf-image-choose], [data-pqcf-image-change], [data-pqcf-image-remove]'
          )
        );

      controls.forEach((control) => {
        if (control.disabled !== disabled) {
          control.disabled = disabled;
        }
      });
    }

    getRowSelectors(row) {
      return (
        this._rowOptions.get(row) ||
        Array.from(
          row.querySelectorAll('[data-pqcf-option]')
        ).sort(
          (a, b) =>
            Number(a.dataset.optionPosition) -
            Number(b.dataset.optionPosition)
        )
      );
    }

    getRowSelections(row) {
      return this.getRowSelectors(row).map(
        (select) => String(select.value)
      );
    }

    findExactVariant(selections) {
      return (
        this.variantOptionsMap.get(
          this.makeVariantOptionsKey(selections)
        ) ||
        null
      );
    }

    getVariantsForPrefix(selections, length) {
      const safeLength = Math.max(0, Number(length) || 0);

      if (safeLength === 0) {
        return this.variants;
      }

      return (
        this.variantPrefixMap.get(
          this.makeVariantPrefixKey(
            selections,
            safeLength
          )
        ) ||
        []
      );
    }

    getVariantsForOptionValue(index, value) {
      return (
        this.variantValueMap.get(
          this.makeVariantValueKey(index, value)
        ) ||
        []
      );
    }
        chooseBestVariant(candidates, previousSelections, changedOptionIndex = -1) {
      if (!candidates?.length) return null;

      let best = null;
      let bestScore = -1;
      let bestAvailable = -1;

      candidates.forEach((variant) => {
        let score = 0;

        variant.options.forEach((value, index) => {
          if (index === changedOptionIndex) return;
          if (String(value) === String(previousSelections[index] ?? '')) {
            score += 1;
          }
        });

        const availableScore = variant.available ? 1 : 0;

        if (
          !best ||
          score > bestScore ||
          (score === bestScore && availableScore > bestAvailable)
        ) {
          best = variant;
          bestScore = score;
          bestAvailable = availableScore;
        }
      });

      return best;
    }

    syncSelectorsToVariant(row, variant) {
      const selectors = this.getRowSelectors(row);

      selectors.forEach((select, index) => {
        const nextValue = variant?.options?.[index];
        if (typeof nextValue === 'undefined') return;

        const normalizedValue = String(nextValue);
        if (select.value !== normalizedValue) {
          select.value = normalizedValue;
        }
      });
    }

    refreshOptionAvailability(row) {
      const selectors = this.getRowSelectors(row);

      // Work left-to-right and keep this array synchronized with any fallback
      // value we apply. That prevents a downstream selector (e.g. Size) from
      // being filtered against a stale/blank upstream selection.
      const selections = selectors.map((select) => String(select.value));

      selectors.forEach((select, optionIndex) => {
        const catalog =
          this._selectOptionCatalog.get(select) ||
          Array.from(select.options).map((option) => ({
            value: String(option.value),
            label: option.textContent || option.label || String(option.value)
          }));

        if (!this._selectOptionCatalog.has(select)) {
          this._selectOptionCatalog.set(select, catalog);
        }

        const prefixBefore = selections.slice(0, optionIndex);
        const allowed = [];

        catalog.forEach((entry) => {
          const candidateSelections = [
            ...prefixBefore,
            entry.value
          ];

          const candidates =
            this.getVariantsForPrefix(
              candidateSelections,
              optionIndex + 1
            );

          if (candidates.length > 0) {
            allowed.push(entry);
          }
        });

        const currentValues =
          Array.from(select.options).map((option) => String(option.value));

        const nextValues = allowed.map((entry) => entry.value);
        const sameOptions =
          currentValues.length === nextValues.length &&
          currentValues.every((value, index) => value === nextValues[index]);

        const previousValue = String(select.value || '');
        const previousStillAllowed = nextValues.includes(previousValue);
        const fallbackValue =
          previousStillAllowed
            ? previousValue
            : (allowed[0]?.value || '');

        if (!sameOptions) {
          const fragment = document.createDocumentFragment();

          allowed.forEach((entry) => {
            const option = document.createElement('option');
            option.value = entry.value;
            option.textContent = entry.label;
            fragment.appendChild(option);
          });

          select.replaceChildren(fragment);
        }

        // Important: replaceChildren() can leave select.value blank when the old
        // value no longer exists. Always restore a valid value when one exists.
        if (fallbackValue && select.value !== fallbackValue) {
          select.value = fallbackValue;
        }

        selections[optionIndex] = String(select.value || fallbackValue || '');
      });
    }

    resolveRowVariant(
      row,
      announceError = true,
      changedOptionIndex = -1
    ) {
      const selectors = this.getRowSelectors(row);

      if (!selectors.length) {
        return (
          this.variantMap.get(
            String(row.dataset.variantId)
          ) ||
          null
        );
      }

      const selections = selectors.map(
        (select) => String(select.value)
      );

      let variant = this.findExactVariant(selections);

      if (!variant) {
        const changedIndex =
          Number.isInteger(changedOptionIndex) &&
          changedOptionIndex >= 0 &&
          changedOptionIndex < selections.length
            ? changedOptionIndex
            : -1;

        if (changedIndex >= 0) {
          // Normal Shopify cascade: preserve every option up to and including
          // the user's changed option, then normalize only downstream options.
          const prefixCandidates =
            this.getVariantsForPrefix(
              selections,
              changedIndex + 1
            );

          variant = this.chooseBestVariant(
            prefixCandidates,
            selections,
            changedIndex
          );

          // Defensive fallback for a value injected by another script or stale DOM:
          // preserve the value the user changed whenever that value exists anywhere.
          if (!variant) {
            variant = this.chooseBestVariant(
              this.getVariantsForOptionValue(
                changedIndex,
                selections[changedIndex]
              ),
              selections,
              changedIndex
            );
          }
        } else {
          const currentVariant =
            this.variantMap.get(
              String(row.dataset.variantId || '')
            ) ||
            null;

          variant =
            currentVariant ||
            this.variants.find((item) => item.available) ||
            this.variants[0] ||
            null;
        }
      }

      if (!variant) {
        row.dataset.variantId = '';
        row.dataset.available = 'false';
        row.classList.add('pqcf__item--unavailable');

        if (announceError) {
          this.showRowError(
            row,
            'Unable to resolve a valid variant.'
          );
        }

        this.refreshOptionAvailability(row);
        return null;
      }

      this.syncSelectorsToVariant(row, variant);
      this.refreshOptionAvailability(row);
      this.applyVariantToRow(
        row,
        variant,
        announceError
      );

      this.debug('variant resolved', {
        itemIndex: row.dataset.itemIndex,
        changedOptionIndex,
        selections,
        resolvedOptions: variant.options,
        variantId: variant.id,
        available: variant.available
      });

      return variant;
    }

    applyVariantToRow(
      row,
      variant,
      announceError = true
    ) {
      row.dataset.variantId =
        String(variant.id);

      row.dataset.available =
        variant.available
          ? 'true'
          : 'false';

      row.dataset.price =
        String(
          Number(
            variant.price || 0
          )
        );

      row.dataset.comparePrice =
        String(
          Number(
            variant.compare_at_price ||
            0
          )
        );

      row.classList.toggle(
        'pqcf__item--unavailable',
        !variant.available
      );

      const title =
        row.querySelector(
          '[data-pqcf-variant-title]'
        );

      if (title) {
        const nextTitle = variant.title || '';
        if (title.textContent !== nextTitle) {
          title.textContent = nextTitle;
        }
      }

      const image =
        row.querySelector(
          '[data-pqcf-variant-image]'
        );

      if (
        image &&
        variant.featured_image &&
        image.getAttribute('src') !== String(variant.featured_image)
      ) {
        image.src = variant.featured_image;
      }

      if (
        !variant.available &&
        announceError
      ) {
        this.showRowError(
          row,
          'This variant is sold out.'
        );
      } else {
        this.clearRowError(row);
      }
    }

    refreshAllOfferPrices() {
      this.offers.forEach(
        (offer) =>
          this.updateOfferPrice(
            offer
          )
      );
    }

    updateOfferPrice(offer) {
      if (!offer) return;

      const rows =
        this.getOfferRows(offer);

      const total =
        rows.reduce(
          (sum, row) =>
            sum +
            Number(
              row.dataset.price || 0
            ),
          0
        );

      const compareTotal =
        rows.reduce(
          (sum, row) => {
            const price =
              Number(
                row.dataset.price || 0
              );

            const compare =
              Number(
                row.dataset.comparePrice ||
                0
              );

            return (
              sum +
              Math.max(
                price,
                compare || 0
              )
            );
          },
          0
        );
              const percent =
        Math.max(
          0,
          Number(
            offer.dataset.percentOff ||
            0
          )
        );

      const fixed =
        this.parseMoneyInputToCents(
          offer.dataset.fixedOff ||
          '0'
        );

      const percentDiscount =
        Math.round(
          total *
          (
            percent /
            100
          )
        );

      const discount =
        Math.min(
          total,
          percentDiscount +
          fixed
        );

      const displayPrice =
        Math.max(
          0,
          total -
          discount
        );

      const displayCompare =
        Math.max(
          compareTotal,
          total
        );

      const amountSaved =
        Math.max(
          0,
          displayCompare -
          displayPrice
        );

      const quantity =
        Number(
          offer.dataset.quantity ||
          rows.length ||
          0
        );

      const tokens = {
        quantity:
          String(quantity),

        price:
          this.formatMoney(
            displayPrice
          ),

        compare_price:
          this.formatMoney(
            displayCompare
          ),

        amount_saved:
          this.formatMoney(
            amountSaved
          ),

        amount_saved_rounded:
          this.formatMoney(
            Math.round(
              amountSaved /
              100
            ) *
            100
          )
      };

      const ui =
        this._offerUi.get(offer) || {};

      const priceEl = ui.price || null;
      const compareEl = ui.compare || null;
      const labelEl = ui.label || null;
      const captionEl = ui.caption || null;
      const savingsEl = ui.savings || null;

      if (priceEl) {
        priceEl.textContent =
          tokens.price;
      }

      if (compareEl) {
        compareEl.textContent =
          displayCompare >
          displayPrice
            ? tokens.compare_price
            : '';

        compareEl.hidden =
          displayCompare <=
          displayPrice;
      }

      if (labelEl) {
        labelEl.innerHTML =
          this.replaceTokens(
            offer.dataset
              .labelTemplate ||
            '',
            tokens
          );
      }

      if (captionEl) {
        captionEl.innerHTML =
          this.replaceTokens(
            offer.dataset
              .captionTemplate ||
            '',
            tokens
          );
      }

      if (savingsEl) {
        const savingsTemplate =
          String(
            offer.dataset
              .savingsTemplate ||
            ''
          ).trim();

        const showSavings =
          amountSaved > 0 &&
          savingsTemplate.length > 0;

        savingsEl.hidden =
          !showSavings;

        savingsEl.innerHTML =
          showSavings
            ? this.replaceTokens(
                savingsTemplate,
                tokens
              )
            : '';
      }

      if (
        offer.dataset.active ===
        'true'
      ) {
        this.syncDefaultAtcPrice(
          displayPrice
        );
      }
    }

    replaceTokens(
      template,
      tokens
    ) {
      return String(
        template || ''
      )
        .replaceAll(
          '[quantity]',
          tokens.quantity
        )
        .replaceAll(
          '[price]',
          tokens.price
        )
        .replaceAll(
          '[compare_price]',
          tokens.compare_price
        )
        .replaceAll(
          '[amount_saved]',
          tokens.amount_saved
        )
        .replaceAll(
          '[amount_saved_rounded]',
          tokens.amount_saved_rounded
        );
    }

    parseMoneyInputToCents(value) {
      const normalized =
        String(
          value || '0'
        )
          .replace(
            /[^0-9.,-]/g,
            ''
          )
          .replace(
            ',',
            '.'
          );

      const number =
        Number.parseFloat(
          normalized
        );

      return Number.isFinite(
        number
      )
        ? Math.max(
            0,
            Math.round(
              number * 100
            )
          )
        : 0;
    }

    formatMoney(cents) {
      const format =
        this.dataset.moneyFormat ||
        '${{amount}}';

      const value =
        Number(
          cents || 0
        );

      const placeholderRegex =
        /\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator|amount_with_apostrophe_separator)\s*\}\}/;

      const match =
        format.match(
          placeholderRegex
        );

      const type =
        match
          ? match[1]
          : 'amount';

      const withDelimiters = (
        number,
        precision = 2,
        thousands = ',',
        decimal = '.'
      ) => {
        const n =
          Number(number);

        const fixed =
          (
            n / 100
          ).toFixed(
            precision
          );

        const parts =
          fixed.split('.');

        parts[0] =
          parts[0].replace(
            /\B(?=(\d{3})+(?!\d))/g,
            thousands
          );

        return parts[1]
          ? `${parts[0]}${decimal}${parts[1]}`
          : parts[0];
      };

      let formatted;

      switch (type) {
        case 'amount_no_decimals':
          formatted =
            withDelimiters(
              value,
              0,
              ',',
              '.'
            );
          break;

        case 'amount_with_comma_separator':
          formatted =
            withDelimiters(
              value,
              2,
              '.',
              ','
            );
          break;

        case 'amount_no_decimals_with_comma_separator':
          formatted =
            withDelimiters(
              value,
              0,
              '.',
              ','
            );
          break;

        case 'amount_with_apostrophe_separator':
          formatted =
            withDelimiters(
              value,
              2,
              "'",
              '.'
            );
          break;

        default:
          formatted =
            withDelimiters(
              value,
              2,
              ',',
              '.'
            );
      }

      return match
        ? format.replace(
            placeholderRegex,
            formatted
          )
        : formatted;
    }

    getActiveOffer() {
      if (
        this._activeOffer?.isConnected &&
        this.contains(this._activeOffer) &&
        this._activeOffer.dataset.active === 'true'
      ) {
        return this._activeOffer;
      }

      this._activeOffer =
        this.querySelector(
          '[data-pqcf-offer][data-active="true"]'
        ) ||
        this.querySelector(
          '.pqcf__offer--selected'
        ) ||
        null;

      return this._activeOffer;
    }

    getActiveRows() {
      return this.getOfferRows(
        this.getActiveOffer()
      );
    }

    getRowItemIndex(row) {
      return Math.max(
        1,
        Number(
          row?.dataset?.itemIndex ||
          1
        ) || 1
      );
    }

    getCustomizationItems() {
      return this._customItems;
    }

    getCustomizationItem(index) {
      return (
        this._customItemMap.get(Number(index)) ||
        null
      );
    }

    getCustomizationItemIndex(item) {
      return Math.max(
        1,
        Number(
          item?.dataset?.itemIndex ||
          1
        ) || 1
      );
    }
        updateCustomizationVisibility() {
      const panel =
        this._customPanel?.isConnected
          ? this._customPanel
          : this.querySelector('[data-pqcf-custom-panel]');

      this._customPanel = panel || null;

      if (!panel) return;

      const quantity =
        Math.max(
          1,
          this.getSelectedQuantity() || 1
        );

      panel.dataset.quantity =
        String(quantity);

      panel.setAttribute(
        'aria-label',
        `Customization for ${quantity} item${quantity === 1 ? '' : 's'}`
      );

      panel.style.setProperty(
        '--pqcf-custom-columns',
        String(quantity)
      );

      this.getCustomizationItems()
        .forEach((item) => {
          const index =
            this.getCustomizationItemIndex(
              item
            );

          const active =
            index <= quantity;

          item.hidden = !active;
          item.setAttribute(
            'aria-hidden',
            active ? 'false' : 'true'
          );

          const controls =
            this._customUi.get(item)?.allControls ||
            [];

          controls.forEach((control) => {
            if (control.disabled === active) {
              control.disabled = !active;
            }
          });

          if (!active) {
            this.clearRowFieldError(item);
            this.clearRowImageError(item);
          }
        });
    }

    isValidImage(file) {
      if (!file) return false;

      const mime =
        String(file.type || '')
          .toLowerCase();

      const validMime = [
        'image/jpeg',
        'image/png',
        'image/webp'
      ];

      const mimeOkay =
        !mime ||
        validMime.includes(mime);

      const extOkay =
        /\.(jpe?g|png|webp)$/i.test(
          String(file.name || '')
        );

      return mimeOkay && extOkay;
    }

    setPhoto(index, file) {
      const numericIndex =
        Math.max(1, Number(index) || 1);

      if (!this.isValidImage(file)) {
        const customItem =
          this.getCustomizationItem(
            numericIndex
          );

        if (customItem) {
          this.showRowImageError(
            customItem,
            'Please choose a JPG, PNG, or WEBP image.'
          );
        }

        return;
      }

      const existing =
        this.photosByIndex.get(
          numericIndex
        );

      if (existing?.previewUrl) {
        URL.revokeObjectURL(
          existing.previewUrl
        );
      }

      this.photosByIndex.set(
        numericIndex,
        {
          file,
          filename:
            file.name ||
            `photo-${numericIndex}`,
          previewUrl:
            URL.createObjectURL(file)
        }
      );

      this.clearGlobalError();
      this.refreshPhotoUIs(
        numericIndex
      );
    }

    removePhoto(index) {
      const numericIndex =
        Math.max(1, Number(index) || 1);

      const existing =
        this.photosByIndex.get(
          numericIndex
        );

      if (existing?.previewUrl) {
        URL.revokeObjectURL(
          existing.previewUrl
        );
      }

      this.photosByIndex.delete(
        numericIndex
      );

      this.refreshPhotoUIs(
        numericIndex
      );
    }

    getPhotoForIndex(index) {
      if (!this.customImageEnabled) {
        return null;
      }

      return (
        this.photosByIndex.get(
          Number(index)
        )?.file ||
        null
      );
    }

    updatePhotoUiForItem(customItem) {
      if (!customItem) return;

      const index =
        this.getCustomizationItemIndex(
          customItem
        );

      const record =
        this.photosByIndex.get(index) ||
        null;

      const ui =
        this._customUi.get(customItem) || {};

      const empty = ui.empty || null;
      const preview = ui.preview || null;
      const image = ui.image || null;
      const filename = ui.filename || null;
      const input = ui.input || null;

      if (!empty && !preview) return;

      if (record) {
        if (empty) empty.hidden = true;
        if (preview) preview.hidden = false;
        if (
          image &&
          image.getAttribute('src') !== record.previewUrl
        ) {
          image.src = record.previewUrl;
        }
        if (filename) {
          filename.textContent =
            record.filename || '';
        }
        this.clearRowImageError(
          customItem
        );
      } else {
        if (empty) empty.hidden = false;
        if (preview) preview.hidden = true;
        if (image) image.removeAttribute('src');
        if (filename) filename.textContent = '';
        if (input) input.value = '';
      }
    }

    refreshPhotoUIs(index = null) {
      if (!this.customImageEnabled) {
        return;
      }

      this.getCustomizationItems()
        .forEach((customItem) => {
          if (
            index !== null &&
            this.getCustomizationItemIndex(
              customItem
            ) !== Number(index)
          ) {
            return;
          }

          this.updatePhotoUiForItem(
            customItem
          );
        });
    }

    showRowImageError(row, message) {
      const error =
        (row ? this._customUi.get(row)?.imageError : null) ||
        row?.querySelector('[data-pqcf-image-error]');

      if (error) {
        error.textContent =
          message ||
          this.customImageRequiredMessage;
        error.hidden = false;
      }

      row?.classList.add(
        'pqcf__item--image-error'
      );
    }

    clearRowImageError(row) {
      const error =
        (row ? this._customUi.get(row)?.imageError : null) ||
        row?.querySelector('[data-pqcf-image-error]');

      if (error) {
        error.hidden = true;
      }

      row?.classList.remove(
        'pqcf__item--image-error'
      );
    }

    getCustomValueForIndex(index) {
      if (!this.customEnabled) {
        return '';
      }

      const customItem =
        this.getCustomizationItem(index);

      if (!customItem) {
        return '';
      }

      const controls =
        this._customUi.get(customItem)?.fieldControls ||
        [];

      if (!controls.length) {
        return '';
      }

      const type =
        customItem.querySelector(
          '[data-pqcf-custom]'
        )?.dataset.fieldType ||
        'text';

      if (
        type === 'pills' ||
        type === 'swatches'
      ) {
        return (
          controls.find(
            (control) =>
              control.checked
          )?.value?.trim() ||
          ''
        );
      }

      return String(
        controls[0].value || ''
      ).trim();
    }

    validateRows(rows) {
      let firstInvalid = null;

      this.clearGlobalError();

      rows.forEach((row) => {
        this.clearRowError(row);

        const variantId =
          row.dataset.variantId;

        const available =
          row.dataset.available ===
          'true';

        if (
          !variantId ||
          !available
        ) {
          this.showRowError(
            row,
            !variantId
              ? 'Please choose an available variant.'
              : 'This variant is sold out.'
          );

          if (!firstInvalid) {
            firstInvalid = row;
          }
        }
      });

      rows.forEach((row) => {
        const itemIndex =
          this.getRowItemIndex(row);

        const customItem =
          this.getCustomizationItem(
            itemIndex
          );

        if (!customItem) return;

        this.clearRowFieldError(
          customItem
        );
        this.clearRowImageError(
          customItem
        );

        if (this.customEnabled) {
          const value =
            this.getCustomValueForIndex(
              itemIndex
            );

          if (
            this.customRequired &&
            !value
          ) {
            this.showRowFieldError(
              customItem,
              this.dataset
                .fieldErrorMessage ||
              'This field is required.'
            );

            if (!firstInvalid) {
              firstInvalid = customItem;
            }
          } else {
            const firstControl =
              (this._customUi.get(customItem)?.fieldControls || [])
                .find((control) => control.type !== 'radio') ||
              null;

            if (
              firstControl &&
              typeof firstControl
                .checkValidity ===
                'function' &&
              !firstControl
                .checkValidity()
            ) {
              this.showRowFieldError(
                customItem,
                firstControl
                  .validationMessage ||
                this.dataset
                  .fieldErrorMessage ||
                'Please check this field.'
              );

              if (!firstInvalid) {
                firstInvalid = customItem;
              }
            }
          }
        }

        if (
          this.customImageEnabled &&
          this.customImageRequired
        ) {
          const photo =
            this.getPhotoForIndex(
              itemIndex
            );

          if (!this.isValidImage(photo)) {
            this.showRowImageError(
              customItem,
              `${this.customImageRequiredMessage} Item #${itemIndex}`
            );

            if (!firstInvalid) {
              firstInvalid = customItem;
            }
          }
        }
      });

      if (!firstInvalid) {
        return true;
      }

      this.showGlobalError(
        this.dataset.atcErrorMessage ||
        'Please complete all required fields.'
      );

      const focusTarget =
        firstInvalid.querySelector(
          '[data-pqcf-field-control], [data-pqcf-image-choose], [data-pqcf-option]'
        );

      if (focusTarget) {
        focusTarget.focus();

        firstInvalid.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }

      return false;
    }
        createGroupId() {
      if (
        window.crypto &&
        typeof window.crypto
          .randomUUID ===
          'function'
      ) {
        return (
          'PQCF-' +
          window.crypto
            .randomUUID()
        );
      }

      return (
        'PQCF-' +
        Date.now() +
        '-' +
        Math.random()
          .toString(36)
          .slice(2, 9)
      );
    }

    buildMainItems(
      rows,
      groupId
    ) {
      return rows.map(
        (
          row,
          index
        ) => {
          const properties = {
            // Keep one private unique reference so Shopify does not merge
            // personalized lines that otherwise have identical variants/properties.
            // Format: <group-id>:<item-index>
            _pqcf_ref:
              `${groupId}:${index + 1}`
          };

          const itemIndex =
            this.getRowItemIndex(
              row
            );

          const customValue =
            this.getCustomValueForIndex(
              itemIndex
            );

          if (
            this.customEnabled &&
            customValue
          ) {
            properties[
              this.propertyName
            ] =
              customValue;
          }

          return {
            id:
              Number(
                row.dataset.variantId
              ),

            quantity:
              1,

            properties
          };
        }
      );
    }

    buildItems(rows) {
      const groupId =
        this.createGroupId();

      return this.buildMainItems(
        rows,
        groupId
      );
    }

    getExternalCustomizationBlock() {
      const scopes = [
        this.productInfo,
        this.productFormElement,
        this.form,
        this.closest('.shopify-section')
      ].filter(Boolean);

      for (const scope of scopes) {
        const candidates = Array.from(
          scope.querySelectorAll(
            'buy-buttons-custom-image[data-cibb-root], buy-buttons-custom-image'
          )
        );

        if (!candidates.length) continue;

        const exact = candidates.find((candidate) => {
          const pqcfBlockId = String(
            candidate.dataset?.pqcfBlockId || ''
          ).trim();

          return pqcfBlockId && pqcfBlockId === this.blockId;
        });

        if (exact) return exact;

        const sameSection = candidates.find((candidate) =>
          String(candidate.dataset?.sectionId || '') === this.sectionId
        );

        if (sameSection) return sameSection;

        return candidates[0];
      }

      return null;
    }

    prepareExternalCustomization(rows) {
      // PQCF's own Theme Editor toggles are the source of truth.
      // Do not fall back to any legacy/external customization block when
      // Custom Image is disabled; doing so can make OFF toggles still validate
      // or add external Name/Photo properties.
      const items = this.buildItems(rows);

      if (!this.customImageEnabled) {
        return {
          customBlock: null,
          payload: {
            source: 'internal-pqcf',
            quantity: rows.length
          },
          items,
          files: new Map(),
          photoPropertyName: this.customImagePropertyName,
          hasFiles: false,
          invalid: false
        };
      }

      const files = new Map();

      rows.forEach((row, rowIndex) => {
        const itemIndex =
          this.getRowItemIndex(row);

        const file =
          this.getPhotoForIndex(itemIndex);

        if (file) {
          files.set(rowIndex, file);
        }
      });

      return {
        customBlock: null,
        payload: {
          source: 'internal-pqcf',
          quantity: rows.length,
          customImagePropertyName:
            this.customImagePropertyName
        },
        items,
        files,
        photoPropertyName:
          this.customImagePropertyName,
        hasFiles: files.size > 0,
        invalid: false
      };
    }

    async parseCartResponse(response) {
      let data = {};

      try {
        data = await response.json();
      } catch (_) {}

      if (!response.ok) {
        let message =
          data?.description ||
          data?.message ||
          '';

        if (!message && data?.errors) {
          if (typeof data.errors === 'string') {
            message = data.errors;
          } else if (typeof data.errors === 'object') {
            message = Object.entries(data.errors)
              .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : String(value)}`)
              .join(' | ');
          }
        }

        throw new Error(
          message ||
          `Unable to add these items to cart. (${response.status})`
        );
      }

      return data;
    }

    async rollbackAddedCartLines(responses) {
      const keys = (responses || [])
        .map((entry) => entry?.key)
        .filter(Boolean)
        .reverse();

      if (!keys.length) return;

      for (const key of keys) {
        try {
          await fetch(
            window.Shopify?.routes?.root
              ? `${window.Shopify.routes.root}cart/change.js`
              : '/cart/change.js',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                id: key,
                quantity: 0
              })
            }
          );
        } catch (_) {}
      }
    }

    getCartAddUrl() {
      return (
        window.routes?.cart_add_url ||
        (
          window.Shopify?.routes?.root
            ? `${window.Shopify.routes.root}cart/add.js`
            : '/cart/add.js'
        )
      );
    }

    getBundledSectionRequest() {
      return {
        sections: [
          'cart-drawer',
          'cart-icon-bubble'
        ],
        sections_url:
          window.location.pathname || '/'
      };
    }

    hasUsableBundledSections(cartData) {
      const sections = cartData?.sections;

      if (!sections || typeof sections !== 'object') {
        return false;
      }

      return [
        'cart-drawer',
        'cart-icon-bubble'
      ].every(
        (sectionId) =>
          typeof sections[sectionId] === 'string'
      );
    }

    getBundledCartData(addData) {
      if (Array.isArray(addData)) {
        return addData[addData.length - 1] || null;
      }

      return addData || null;
    }

    renderShrineCart(cartData) {
      const drawer =
        this.getCartDrawer();

      if (
        !drawer ||
        typeof drawer
          .renderContents !==
          'function'
      ) {
        return false;
      }

      drawer.renderContents(
        cartData
      );

      let drawerEl =
        this._cartDrawerEl;

      if (!drawerEl?.isConnected) {
        drawerEl = drawer.matches?.('cart-drawer.drawer')
          ? drawer
          : document.querySelector('cart-drawer.drawer');
        this._cartDrawerEl = drawerEl || null;
      }

      if (drawerEl?.classList.contains('is-empty')) {
        drawerEl.classList.remove('is-empty');
      }

      return true;
    }

    async addJsonItemsToCart(items) {
      const response = await fetch(
        this.getCartAddUrl(),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items,
            ...this.getBundledSectionRequest()
          })
        }
      );

      return this.parseCartResponse(response);
    }

    appendPropertiesToFormData(formData, properties) {
      Object.entries(properties || {}).forEach(([key, value]) => {
        if (
          value === null ||
          typeof value === 'undefined' ||
          String(value) === ''
        ) {
          return;
        }

        formData.append(
          `properties[${key}]`,
          String(value)
        );
      });
    }
        async addFormDataItemsToCart(
      items,
      files,
      photoPropertyName
    ) {
      const responses = [];
      const addUrl =
        this.getCartAddUrl();

      const startedAt =
        typeof performance !== 'undefined'
          ? performance.now()
          : Date.now();

      try {
        for (let index = 0; index < items.length; index += 1) {
          const item = items[index];
          const formData = new FormData();
          const itemStartedAt =
            typeof performance !== 'undefined'
              ? performance.now()
              : Date.now();

          formData.append('id', String(item.id));
          formData.append(
            'quantity',
            String(item.quantity || 1)
          );

          this.appendPropertiesToFormData(
            formData,
            item.properties
          );

          const file = files.get(index);

          if (file) {
            formData.append(
              `properties[${photoPropertyName}]`,
              file,
              file.name || `photo-${index + 1}`
            );
          }

          // File line-item properties require multipart FormData. Keep cart
          // mutations sequential for stability, but request rendered sections
          // only on the final mutation so the earlier uploads stay lightweight.
          if (index === items.length - 1) {
            const sectionRequest =
              this.getBundledSectionRequest();

            formData.append(
              'sections',
              sectionRequest.sections.join(',')
            );
            formData.append(
              'sections_url',
              sectionRequest.sections_url
            );
          }

          this.debug('upload item start', {
            item: index + 1,
            total: items.length,
            variantId: item.id,
            hasFile: !!file,
            fileSize: file?.size || 0,
            fileType: file?.type || ''
          });

          const response = await fetch(addUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          const parsed =
            await this.parseCartResponse(response);

          responses.push(parsed);

          const itemEndedAt =
            typeof performance !== 'undefined'
              ? performance.now()
              : Date.now();

          this.debug('upload item complete', {
            item: index + 1,
            total: items.length,
            durationMs: Math.round(itemEndedAt - itemStartedAt)
          });
        }
      } catch (error) {
        this.debug('upload failed; rolling back', {
          completed: responses.length,
          message: error?.message || String(error)
        });
        await this.rollbackAddedCartLines(responses);
        throw error;
      }

      const endedAt =
        typeof performance !== 'undefined'
          ? performance.now()
          : Date.now();

      this.debug('all file uploads complete', {
        itemCount: items.length,
        durationMs: Math.round(endedAt - startedAt)
      });

      return responses;
    }

    getSelectedQuantity() {
      const offer =
        this.getActiveOffer();

      return Math.max(
        0,
        Number(
          offer?.dataset.quantity ||
          0
        )
      );
    }

    /*
     * Both Product and Free Shipping cards
     * use the same threshold system.
     *
     * Free Shipping does NOT require
     * inventory or a variant ID.
     */
    updateGiftStates() {
      if (
        !this.showGifts ||
        !this.gifts.length
      ) {
        return;
      }

      const quantity =
        this.getSelectedQuantity();

      this.gifts.forEach(
        (gift) => {
          const type =
            gift.dataset.giftType ||
            'product';

          const threshold =
            Math.max(
              1,
              Number(
                gift.dataset
                  .unlockQuantity ||
                1
              )
            );

          const available =
            type === 'free_shipping'
              ? true
              : gift.dataset
                  .available ===
                'true';

          const unlocked =
            available &&
            quantity >=
            threshold;

          gift.dataset.unlocked =
            unlocked
              ? 'true'
              : 'false';

          gift.classList.toggle(
            'pqcf__gift--unlocked',
            unlocked
          );

          gift.classList.toggle(
            'pqcf__gift--locked',
            !unlocked
          );

          gift.classList.toggle(
            'pqcf__gift--unavailable',
            !available
          );

          const lock =
            this._giftLocks.get(gift) ||
            null;

          if (lock) {
            lock.hidden =
              unlocked;
          }
        }
      );
    }

    syncDefaultAtcPrice(cents) {
      const holder =
        document.getElementById(
          `main-atc-price-${this.sectionId}`
        );

      if (!holder) return;

      const priceSpan =
        holder.querySelector(
          '[class*="main-atc-price-span-"]'
        );

      if (priceSpan) {
        priceSpan.textContent =
          this.formatMoney(
            cents
          );
      }
    }

    applyAlternativeButtonPolicy() {
      if (!this.productFormElement) {
        return;
      }

      this.productFormElement
        .classList
        .add(
          'pqcf-product-form--active'
        );

      if (
        this.hideAlternativeButtons
      ) {
        this.productFormElement
          .classList
          .add(
            'pqcf-product-form--hide-alt'
          );
      }
    }

    removeAlternativeButtonPolicy() {
      if (!this.productFormElement) {
        return;
      }

      this.productFormElement
        .classList
        .remove(
          'pqcf-product-form--active',
          'pqcf-product-form--hide-alt'
        );
    }

    onProductAreaClickCapture(
      event
    ) {
      const mainButton =
        event.target.closest(
          `#ProductSubmitButton-${CSS.escape(
            this.sectionId
          )}`
        );

      const secondaryButton =
        event.target.closest(
          `#SectionAtcBtn-${CSS.escape(
            this.sectionId
          )}`
        );

      if (
        !mainButton &&
        !secondaryButton
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (this.isSubmitting) {
        return;
      }

      this.submitBundle(
        mainButton ||
        secondaryButton
      );
    }

    onProductAreaSubmitCapture(
      event
    ) {
      if (
        !this.isRelevantForm(
          event.target
        )
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (this.isSubmitting) {
        return;
      }

      this.submitBundle(
        event.submitter ||
        this.mainButton
      );
    }

    isRelevantForm(form) {
      return (
        !!form &&
        form.id ===
          this.productFormId
      );
    }

    async submitBundle(
      triggerButton
    ) {
      if (this.isSubmitting) {
        return;
      }

      const submitStartedAt =
        typeof performance !== 'undefined'
          ? performance.now()
          : Date.now();

      const rows = this.getActiveRows();

      if (!rows.length) {
        this.showGlobalError(
          'Please select an offer.'
        );

        return;
      }

      if (!this.validateRows(rows)) {
        return;
      }

      const prepared =
        this.prepareExternalCustomization(
          rows
        );

      if (prepared.invalid) {
        this.showGlobalError(
          'Please complete all required personalization and photo fields.'
        );

        return;
      }

      const items = prepared.items;

      const invalidItem = items.find((item) => {
        const id = Number(item.id);
        return !id || !this.variantMap.has(String(id));
      });

      if (
        !items.length ||
        invalidItem
      ) {
        this.showGlobalError(
          'Unable to build the selected items.'
        );

        return;
      }

      this.isSubmitting = true;

      this.setLoading(
        triggerButton,
        true
      );

      this.clearButtonError(
        triggerButton
      );

      this.clearGlobalError();

      this.debug(
        'cart payload',
        {
          itemCount: items.length,
          items,
          customizationSource:
            prepared.payload?.source ||
            (prepared.customBlock ? 'external-block' : 'pqcf'),
          hasFiles: prepared.hasFiles,
          photoPropertyName:
            prepared.photoPropertyName
        }
      );
            try {
        const addData = prepared.hasFiles
          ? await this.addFormDataItemsToCart(
              items,
              prepared.files,
              prepared.photoPropertyName
            )
          : await this.addJsonItemsToCart(
              items
            );

        this.debug(
          'add success',
          addData
        );

        const bundledCartData =
          this.getBundledCartData(
            addData
          );

        let cartData =
          bundledCartData;

        let renderedFromAdd =
          false;

        if (
          this.hasUsableBundledSections(
            bundledCartData
          )
        ) {
          try {
            renderedFromAdd =
              this.renderShrineCart(
                bundledCartData
              );
          } catch (renderError) {
            this.debug(
              'bundled cart render failed; using refresh fallback',
              renderError
            );
          }
        }

        // Safety fallback: preserve the old Shrine refresh behavior if the
        // bundled sections are missing, null, or the theme cannot render them.
        if (!renderedFromAdd) {
          cartData =
            await this.refreshShrineCart();

          this.debug(
            'cart refreshed via fallback',
            cartData
          );
        } else {
          this.debug(
            'cart rendered from bundled add response',
            cartData
          );
        }

        this.dispatchEvent(
          new CustomEvent(
            'pqcf:added',
            {
              bubbles: true,
              detail: {
                items,
                response: addData,
                cart: cartData,
                customization:
                  prepared.payload || null
              }
            }
          )
        );
      } catch (error) {
        console.error(
          '[PQCF] Add to cart failed',
          error
        );

        this.showButtonError(
          triggerButton,
          error.message ||
          'Unable to add to cart.'
        );

        this.showGlobalError(
          error.message ||
          'Unable to add to cart.'
        );
      } finally {
        const submitEndedAt =
          typeof performance !== 'undefined'
            ? performance.now()
            : Date.now();

        this.debug('add-to-cart total', {
          durationMs: Math.round(submitEndedAt - submitStartedAt),
          rowCount: rows.length,
          hasFiles: prepared.hasFiles
        });

        this.isSubmitting = false;

        this.setLoading(
          triggerButton,
          false
        );
      }
    }

    async refreshShrineCart() {
      const response =
        await fetch(
          '/cart/update.js',
          {
            method:
              'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json',

              'X-Requested-With':
                'XMLHttpRequest'
            },

            body:
              JSON.stringify({
                updates: {},

                sections: [
                  'cart-drawer',
                  'cart-icon-bubble'
                ],

                sections_url:
                  window.location.pathname
              })
          }
        );

      let cartData =
        {};

      try {
        cartData =
          await response.json();
      } catch (_) {}

      if (!response.ok) {
        throw new Error(
          cartData?.description ||
          cartData?.message ||
          'Unable to refresh cart.'
        );
      }

      this.renderShrineCart(
        cartData
      );

      return cartData;
    }

    onExternalChange(event) {
      if (
        this.enableVariantSelectors ||
        this.contains(
          event.target
        )
      ) {
        return;
      }

      const productInfo =
        event.target.closest(
          `#ProductInfo-${CSS.escape(
            this.sectionId
          )}`
        );

      if (!productInfo) {
        return;
      }

      window.setTimeout(
        () =>
          this.syncRowsToMainVariant(),
        0
      );
    }

    syncRowsToMainVariant() {
      if (
        this.enableVariantSelectors ||
        !this.form
      ) {
        return;
      }

      const idInput =
        this.form.querySelector(
          'input[name="id"]'
        );

      if (!idInput?.value) {
        return;
      }

      const variant =
        this.variantMap.get(
          String(
            idInput.value
          )
        );

      if (!variant) {
        return;
      }

      this.offers.forEach((offer) => {
        this.getOfferRows(offer).forEach((row) => {
          this.applyVariantToRow(
            row,
            variant,
            false
          );
        });
      });

      this.refreshAllOfferPrices();
    }

    setLoading(
      button,
      loading
    ) {
      const target =
        button ||
        this.mainButton;

      if (!target) return;

      if (loading) {
        target.dataset
          .pqcfWasDisabled =
          target.disabled
            ? 'true'
            : 'false';

        target.disabled =
          true;
      } else if (
        target.dataset
          .pqcfWasDisabled !==
        'true'
      ) {
        target.disabled =
          false;
      }

      target.classList.toggle(
        'loading',
        loading
      );

      target.setAttribute(
        'aria-busy',
        loading
          ? 'true'
          : 'false'
      );

      const spinner =
        target.querySelector(
          '.loading-overlay__spinner'
        );

      if (spinner) {
        spinner.classList.toggle(
          'hidden',
          !loading
        );
      }

      if (!loading) {
        delete target.dataset
          .pqcfWasDisabled;
      }
    }

    showButtonError(
      button,
      message
    ) {
      const target =
        button ||
        this.mainButton;

      const error =
        target?.querySelector(
          '.main-atc__error'
        );

      if (!error) return;

      error.textContent =
        message;

      error.style.display =
        '';
    }

    clearButtonError(button) {
      const target =
        button ||
        this.mainButton;

      const error =
        target?.querySelector(
          '.main-atc__error'
        );

      if (!error) return;

      error.textContent = '';
      error.style.display =
        'none';
    }
        showRowFieldError(
      row,
      message
    ) {
      row.classList.add(
        'pqcf__item--error'
      );

      const error =
        this._customUi.get(row)?.fieldError ||
        row.querySelector('[data-pqcf-field-error]');

      if (error) {
        error.textContent =
          message;

        error.hidden =
          false;
      }
    }

    clearRowFieldError(row) {
      row.classList.remove(
        'pqcf__item--error'
      );

      const error =
        this._customUi.get(row)?.fieldError ||
        row.querySelector('[data-pqcf-field-error]');

      if (error) {
        error.hidden =
          true;
      }
    }

    showRowError(
      row,
      message
    ) {
      const error =
        row.querySelector(
          '[data-pqcf-row-error]'
        );

      if (error) {
        error.textContent =
          message;

        error.hidden =
          false;
      }
    }

    clearRowError(row) {
      const error =
        row.querySelector(
          '[data-pqcf-row-error]'
        );

      if (error) {
        error.hidden =
          true;
      }
    }

    showGlobalError(message) {
      const error =
        this.querySelector(
          '[data-pqcf-global-error]'
        );

      if (!error) return;

      error.textContent =
        message;

      error.hidden =
        false;
    }

    clearGlobalError() {
      const error =
        this.querySelector(
          '[data-pqcf-global-error]'
        );

      if (!error) return;

      error.textContent = '';
      error.hidden = true;
    }

    debug(
      message,
      data
    ) {
      if (!this.debugEnabled) {
        return;
      }

      if (
        typeof data ===
        'undefined'
      ) {
        console.log(
          `[PQCF] ${message}`
        );
      } else {
        console.log(
          `[PQCF] ${message}`,
          data
        );
      }
    }
  }

  customElements.define(
    TAG,
    ProductQuantityCustomFields
  );
})();